import * as React from 'react'

import * as env from '../env'
import * as schema from '../schema'
import * as utils from '../utils'
import { Customer, MediaItem, MediaKind } from '../schema'
import { Writable, isBetween, range, stringIsInt } from '../utils'

export type FieldToTrait<T> = Partial<Readonly<Record<schema.CustomerField, T>>>

export const fieldToLabel: FieldToTrait<string> = {
  //#region airConditioner
  air_conditioner: 'Air Conditioner',
  air_conditioner_current_tons: 'How many tons is your current AC?',
  air_conditioner_furnance: 'Will you include the furnance?',
  air_conditioner_new_tons: 'How many tons will the new AC be? ',
  air_conditioner_replace_ducts: 'Are you replacing ducts?',
  air_conditioner_unit_type: 'What type AC unit are you going to  install?',
  air_conditioner_working: 'Do you currently have an AC?',
  air_conditioner_swamp_cooler_use: 'Are you using a swamp cooler?',
  air_conditioner_swamp_cooler_use_remove:
    'Would you be removing any swamp coolers?',
  //#endregion
  //#region atticFan
  attic_fan_quantity: 'How many?',
  attic_fan: 'Attic Fan',
  //#endregion
  //#region atticInsulation
  attic_insulation_type: 'What type of insulation?',
  attic_insulation: 'Attic Insulation',
  attic_insulation_how_much: 'Square footage to be insulated',
  //#endregion
  attic_square_footage: 'Attic square footage',
  //#region battery
  battery_type: 'Select battery type',
  battery_size: 'Select battery size',
  battery: 'Battery',
  //#endregion

  //#region constructionWork
  construction_work: 'Big Additions / New Construction',
  //#endregion

  buildingType: 'Building type',

  //#region batteryMultiple
  battery_multiple: 'Batteries',
  battery_multiple_bank_location: 'Battery type',
  battery_multiple_customer_material: 'Is homeowner providing material?',
  battery_multiple_distance_to_main_panel: 'Distance from bank to main panel',
  battery_multiple_how_many: 'How many batteries?',
  //#endregion

  //#region
  cash_amount: 'Cashback amount',
  cash_pool_pumps: 'Pool Pumps',
  cash_heat_pumps: 'Heat Pumps',
  cash_whole_house_fans_or_ventilation: 'Whole House Fans / Ventilation',
  cash_efficient_boilers: 'Efficient Boilers',
  cash_geothermal_heat_pumps: 'Geothermal Heat Pumps',
  cash_radiant_floors: 'Radiant Floors',
  cash_water_saving_fixtures: 'Water Saving Fixtures',
  cash_solar_water_heaters: 'Solar Water Heaters',
  cash_on_demand_or_tankless_hot: 'On Demand / Tank-less Hot Water Heater',
  cash_efficient_water_heaters: 'Efficient Water Heaters',
  cash_artificial_turf: 'Artificial Turf',
  cash_irrigation_systems: 'Irrigation Systems',
  cash_windows: 'Windows',
  cash_air_conditioner: 'Air Conditioner',
  cash_floor_insulation: 'Floor Insulation',
  cash: 'Cash',
  //#endregion
  createdAt: 'Created at',
  crm_id: 'Crm Id',
  //#region custom
  custom_eight_fields_name: 'Name',
  custom_eight_fields: 'Custom 8',
  custom_fields_name: 'Name',
  custom_fields: 'Custom 1',
  custom_five_fields_name: 'Name',
  custom_five_fields: 'Custom 5',
  custom_four_fields_cost: 'Cost',
  custom_four_fields_name: 'Name',
  custom_four_fields: 'Custom 4',
  custom_nine_fields_name: 'Name',
  custom_nine_fields: 'Custom 9',
  custom_seven_fields_name: 'Name',
  custom_seven_fields: 'Custom 7',
  custom_six_fields_cost: 'Cost',
  custom_six_fields_name: 'Name',
  custom_six_fields: 'Custom 6',
  custom_ten_fields_cost: 'Cost',
  custom_ten_fields_name: 'Name',
  custom_ten_fields: 'Custom 10',
  custom_three_fields_name: 'Name',
  custom_three_fields: 'Custom 3',
  custom_two_fields_name: 'Name',
  custom_two_fields: 'Custom 2',
  //#endregion
  customerAddress: 'Customer address',
  customerEmail: 'Customer email',
  customerName: 'Customer name',
  customerPhone: 'Customer phone',
  customerPhoneAlt: 'Alt phone number (opt)',
  date: 'Created at',

  can_light_new: 'Can lights',
  can_light_new_how_many: 'How many can lights will be installed?',
  can_light_new_will_remove: 'Will you be removing any existing can lights?',
  can_light_new_will_remove_how_many: 'How many can lights will be removed?',
  can_light_new_high_ceiling: 'Are any of the ceilings above 12ft?',

  ceiling_fan: 'Ceiling Fan',

  derate: 'Derate',
  derate_cost: 'Cost',
  duct_insulation_cost: 'Cost',
  duct_insulation: 'Duct Insulation',
  duct_repair_quantity: 'How many?',
  duct_repair: 'Duct Repair',
  //#region duct_replacement
  duct_replacement: 'Duct Replacement',
  duct_replacement_qty: 'How many ducts will be replaced?',
  //#endregion duct_replacement
  duct_seal_cost: 'Cost',
  duct_seal: 'Duct Seal',
  flat_roof_panels: 'Flat Roof Panels',
  flat_roof_panels_cost: 'Cost',
  flat_roof_panels_how_many: 'How many?',
  globalNotes: 'Global customer notes',
  glow: 'Protocol Fee (Glow Gold)',
  glow_price_per_watt: 'Price Per Kw/h from the utility bill',
  glow_power_output_mw: 'System Size in Kw',

  home_run: 'New Home Runs',
  home_run_ft: 'How many feet?',

  incentive_adders_description: 'Incentive/Adders Description',

  inverter_swap: 'Inverter',
  inverter_swap_qty: 'How many inverters?',
  inverter_swap_customer_material: 'Is homeowner providing material?',
  inverter_swap_size: 'Size',
  inverter_swap_distance_to_mpu: 'Distance to main panel',

  main_panel_location: 'Where is the main panel?',
  main_panel_upgrade: 'Main Panel Upgrade (MPU)',
  main_panel_upgrade_rating: 'Rating (in amps)',
  main_panel_upgrade_needed_or_requested: 'Is needed or requested by customer?',
  main_panel_upgrade_installation_company: 'Installer',

  mini_split: 'Mini Split',
  mini_split_ton1: 'Mini Split System 1Ton',
  mini_split_ton2: 'Mini Split System 2Ton',
  mini_split_cost: 'Cost',
  new_ducts_description: 'Description',
  new_ducts_quantity: 'How many?',
  new_ducts_replace: 'Replacing ducts?',
  new_ducts: 'New Ducts',
  //#region new_windows
  new_windows_areas: 'What areas?',
  new_windows_color: 'Window colors',
  new_windows_cost: 'Cost',
  new_windows_grid: 'Grid windows?',
  new_windows_quantity: 'Total Number of Windows',
  new_windows_sqft_each_window: 'Sqft of each window?',
  new_windows_sliding_glass_sqft: 'Feet of each sliding glass door?',
  new_windows_sliding_glass: 'Sliding glass doors included?',
  new_windows_sliding_glass_how_many:
    'Total Number of Glass Sliding Doors included:',
  new_windows_sqft: 'How Much Square Footage?',
  new_windows_replace: 'Are you replacing the windows on the whole house?',
  new_windows_replace_custom:
    'What areas of home windows will be installed in detail?',
  new_windows: 'Windows',
  new_windows_california_city: 'Choose a city',
  new_windows_sliding_glass_size: 'Sliding glass door Size',
  newWindows: 'Windows & Sliding Glass Doors',
  //#endregion new_windows
  //#region nirvanaPanels
  nirvana_panels: 'Solar Panels',
  nirvana_panels_panel_scenario: 'Main panel scenario',
  nirvana_panels_how_many: 'How many panels?',
  nirvana_panels_distance_to_main_panel: 'Distance to main panel',
  //#endregion

  outlet: 'Outlets',

  pool_pump_cost: 'Cost',
  pool_pump: 'Pool Pump',
  //#region protection
  protection: 'Surge Protector',
  protection_which: 'Which type of protection?',
  //#endregion protection
  //#region roof
  roof_cost: 'Cost',
  roof_california_city: 'Choose a city',
  roof_square_footage: 'Roof squares',
  roof_fascia_included: 'Are we including fascia?',
  roof_fascia_included_square_footage:
    'How many linear feet are we going to included?',
  roof_layover_or_tear: 'Choose type of roof work',
  roof_tear_material: 'Material duration',
  roof_patio_included: 'Patio/ flat roof included?',
  roof_patio_how_many: 'How many squares?',
  roof_pitch: 'What is the pitch of the roof?',
  roof_plywood_under_tile: 'Is there plywood under the roof tile?',
  roof_plywood_replaced: 'Will you be replacing all the plywood?',
  roof_plywood_replaced_square: 'How many squares?',
  roof_shingles_or_tiles: 'Shingles or Tiles?',
  roof_will_add_license: 'Pulling permits?',
  roof_commission_add_up: 'Commission add up',
  roof: 'Roof',
  // #endregion roof

  //#region security
  security_alarm_payout: 'Alarm payout',
  security_cams: 'Security Camera',
  security_cams_is_6: 'Is it a 6-cam system?',
  security_system: 'Security System',
  security_tv: 'TVs',
  security_wifi_cameras: 'WiFi Camera',
  //#endregion

  service_and_repair: 'Service and Repairs',
  service_and_repair_hours: 'Hours',

  small_system_size: 'System size',
  small_system_extra_batteries_qty: 'How many?',
  small_system_extra_batteries_will: 'Will you install additional batteries?',

  // smart_home: 'Smart Home',

  // Closer
  homeRep:
    env.CODENAME === 'nirvana'
      ? 'Nirvana representative'
      : 'EcoHome rep (closer)',
  smart_thermostat_how_many: 'How many?',
  smart_thermostat: 'Smart Thermostat',
  solar_tax: 'Solar Tax Consultant',
  solarCompany: 'State',
  products: 'Products',
  solarEmail: 'Solar rep email',
  // Setter
  solarRep: 'Solar rep (setter)',
  sort_key: 'Last update',
  sub_panel_upgrade: 'Sub Panel Upgrade',
  ssn: 'SSN',
  system_size: 'System size',
  small_system: 'Small System',
  homeStoryNumber: 'One or two story building?',
  yearHomeBuilt: 'Year home was built',
  panel_removal: 'Panel Removal',
  panel_removal_how_many: 'How many panels do you need to remove?',

  //#region nirvanaChecklist
  checklist_nirvana_home_owners_info:
    "Home owner's information (Full Name, address and email)",
  checklist_nirvana_product_pics:
    'Pictures from ground to roof of where product will be placed or installed',
  checklist_nirvana_main_panel_pics: 'Picture of main panel (if applicable)',
  checklist_nirvana_main_panel_inside_pics:
    'Picture of inside of main panel (to see if there is space to add breakers)',
  checklist_nirvana_utility_bill: 'Picture of utility bill (if applicable)',
  //#endregion

  //#region checkList
  attach_thermal_camera: 'Attach thermal camera to the phone',

  take_picture_of_home: 'Take picture of home',
  get_debts_report: 'Get debts report',

  perform_energy_assessment: 'Perform energy assessment',
  /**/ use_thermal_camera: 'Use thermal camera',
  /**/ take_quiz: 'Take survey',
  /**/ use_room_that_gets_hot: 'Room that gets hot',
  /**/ use_smoke_pen: 'Use smoke pen',

  take_pictures: 'Take pictures',

  fill_out_prices: 'Fill out prices',

  verify_pricing_or_ppw: 'Verify pricing/PPW (info)',

  show_ecohome_report: `Show ${env.HOLDING_NAME} report`,

  show_solo_report: 'Show Solo report',

  /**/ /**/

  run_credit: 'Run credit',

  change_to_correct_email: 'Change to correct email',

  sign_financing_agreement: 'Sign financing agreement (info)',
  /**/ sign_cosigner: 'Sign co-signer',

  submit_install_docs_in_solo: 'Submit install docs in Solo (info)',
  /**/ counter_sign_rep_install_doc: 'Counter-sign rep install doc (info)',
  /**/ sign_customer_install_docs: 'Sign customer install docs (info)',

  ecohome_report: `${env.HOLDING_NAME} report`,
  /**/ make_sure_ecohome_and_solo_match:
    'Make Sure Ecohome/Solo #s match (info)',
  /**/ take_picture_of_utility_bill: 'Take picture of utility bill',
  /**/ take_picture_of_id: 'Take picture of ID',
  /**/ take_pictures_of_meter: 'Take pictures of meter (example)',
  /**/ submit_detailed_notes_for_efficiencies:
    'Submit detailed notes for efficiencies (info)',
  /**/ review_notes_with_customers: 'Review notes w/ customers',
  /**/ sign_ecohome_report: `Sign ${env.HOLDING_NAME} report`,
  /**/ get_google_review_and_or_pic_with_customer:
    'Get a 5-star Google Review from the client',
  /**/ take_pic_with_customer: 'Take picture with customer',
  /**/ offer_incentives_for_referrals: 'Offer incentives for referrals',

  update_notes_on_HL: 'Update notes on HL',

  report_sale_to_slack: 'Report sale to Slack!',
  //#endregion
  // Roofing Claiming

  //#region roofClaims
  roof_claiming_date: 'Date',
  roof_claiming_homeowner: 'Homeowner',
  roof_claiming_phone: 'Phone',
  roof_claiming_phone_alt: 'Alt Phone',
  roof_claiming_email: 'Email',
  roof_claiming_address: 'Address',
  roof_claiming_city: 'City',
  roof_claiming_zip: 'Zip',
  roof_claiming_deductible: 'Deductible',
  roof_claiming_shingle_manufacturer: 'Shingle Manufacturer',
  roof_claiming_style: 'Style',
  roof_claiming_color: 'Color',
  roof_claiming_drip_color: 'Drip Color',

  roof_claiming_tear_off_layers_shingles: 'Tear off all layers of shingles',
  roof_claiming_install_felt: 'Install Felt',
  roof_claiming_close_valleys: 'Close Valleys ',
  roof_claiming_ridges_color_coordinated: 'Ridges Color Coordinated',
  roof_claiming_install_new_flashings: 'Install New Flashings',
  roof_claiming_replace_ventilation: 'Replace ventilation as needed',
  roof_claiming_install_nails: 'Install nails per code',
  roof_claiming_clean_job_waste_gutters: 'Clean job waste from gutters',
  roof_claiming_two_year_workmanship_warranty: '2 year workmanship warranty ',
  roof_claiming_magnetic_sweep_property:
    'Magnetic sweep property after install ',

  roof_claiming_age: 'Age',
  roof_claiming_layers: 'Layers',
  roof_claiming_predominate_pitch: 'Predominate Pitch',

  roof_claiming_pipe_jack: 'Pipe Jack (QTY)',
  roof_claiming_chimney_flashing: 'Chimney Flashing (QTY)',
  roof_claiming_chimney_cap: 'Chimney Cap (QTY)',
  roof_claiming_digital_satellite: 'Digital Satellite (QTY)',
  roof_claiming_gas_cap: 'Gas Vent/Rain Cap (QTY)',
  roof_claiming_other_one: 'Other',

  roof_claiming_turtle_vent: 'Turtle Vent (QTY)',
  roof_claiming_ridge_vent: 'Ridge Vent (QTY)',
  roof_claiming_turbine_vent: 'Turbine Vent (QTY)',
  roof_claiming_power_attic_vent: 'Power Attic Vent (QTY)',
  roof_claiming_other_two: 'Other',
  roof_claiming_other_three: 'Other',

  /**
   * To be removed
   * @deprecated
   */
  roof_claiming_notes: 'Roof claim notes',
  /**
   * To be removed
   * @deprecated
   */
  roof_claiming_documents_notes: 'Notes',

  roof_claiming_date_loss: 'Date of Loss',
  roof_claiming_insurance_company: 'Insurance Company',
  roof_claiming_claim: 'Claim #',

  roof_claiming_client_sign: 'Client(s) Signature',
  roof_claiming_company_rep_sign: 'Authorized Signature',

  roof_claiming_printed_name: 'Printed Name',
  roof_claiming_completion_client_sign: 'Client(s) Signature',
  roof_claiming_company_rep_sign_date: 'Date',
  roof_claiming_completion_client_sign_date: 'Date',
  //#endregion

  // End Roofing Claiming

  //#region glowQualify
  qualify_glow_birth_date: 'Birth Date',
  qualify_glow_city: 'City',
  qualify_glow_email: 'Email',
  qualify_glow_first_name: 'First Name',
  qualify_glow_last_name: 'Last Name',
  qualify_glow_phone_number: 'Phone Number',
  qualify_glow_ssn: 'Last 4 Digits or Full SSN',
  qualify_glow_state: 'State',
  qualify_glow_street: 'Street',
  qualify_glow_zip: 'Zip',
  //#endregion

  //#region glowIncentive
  incentive_glow_carbon_credits: 'Carbon Credits Produce',
  incentive_glow_cash: 'Glow Cash',
  incentive_glow_tax_deduction: 'Tax Deduction',
  incentive_glow_federal_tax_credit: 'Federal Tax Credit',
  //#endregion
}

/**
 * Will only contain one dependent for now.
 */
export const yesNoToDependent: FieldToTrait<[schema.CustomerField]> = {
  air_conditioner_swamp_cooler_use: ['air_conditioner_swamp_cooler_use_remove'],
  air_conditioner_working: ['air_conditioner_current_tons'],
  can_light_new_will_remove: ['can_light_new_will_remove_how_many'],
  new_windows_replace: ['new_windows_replace_custom'],
  new_windows_sliding_glass: ['new_windows_sliding_glass_sqft'],
  roof_fascia_included: ['roof_fascia_included_square_footage'],
  roof_patio_included: ['roof_patio_how_many'],
  roof_plywood_replaced: ['roof_plywood_replaced_square'],
  small_system_extra_batteries_will: ['small_system_extra_batteries_qty'],
}

export const fieldToDependency: FieldToTrait<schema.CustomerField> = (() => {
  const res = {}
  // @ts-ignore
  for (const [dependency, [dependent]] of utils.entries(yesNoToDependent)) {
    // @ts-ignore
    res[dependent] = dependency
  }
  return res
})()

/**
 * Sub-inputs are guaranteed to be 1 or 2 in length. Inputs should be rendered
 * in the order of this object's keys.
 */
export const adderToInputs: FieldToTrait<schema.CustomerFields> = {
  //#region security
  security_cams: ['security_cams_detail'],
  security_system: ['security_system_detail'],
  security_tv: ['security_tv_detail'],
  security_wifi_cameras: ['security_wifi_cameras_detail'],
  // smart_home: ['smart_home_detail'],
  //#endregion
  attic_insulation: ['attic_insulation_type', 'attic_insulation_how_much'],
  duct_seal: [],
  inverter_swap: [
    'inverter_swap_qty',
    'inverter_swap_size',
    'inverter_swap_distance_to_mpu',
    'inverter_swap_customer_material',
    'main_panel_location',
  ],
  roof: [
    'roof_square_footage',
    'roof_pitch',
    'roof_layover_or_tear',
    'roof_layers_how_many',
    'roof_tear_material',
    'roof_fascia_included',
    'roof_patio_included',
    'roof_plywood_under_tile',
    'roof_plywood_replaced',
    'roof_will_add_license',
    'roof_commission_add_up',
  ],
  new_windows: [
    'new_windows_sqft_each_window',
    'new_windows_color',
    'new_windows_grid',
    'new_windows_sliding_glass',
    'new_windows_replace',
  ],
  air_conditioner: [
    'air_conditioner_working',
    'air_conditioner_replace_ducts',
    'air_conditioner_swamp_cooler_use',
    'air_conditioner_new_tons',
    'air_conditioner_unit_type',
    'air_conditioner_furnance',
  ],
  battery: [
    'main_panel_upgrade_installation_company',
    'battery_type',
    'battery_size',
  ],
  battery_multiple: [
    'battery_multiple_bank_location',
    'battery_multiple_distance_to_main_panel',
    'battery_multiple_how_many',
    'battery_multiple_customer_material',
  ],
  nirvana_panels: [
    'nirvana_panels_panel_scenario',
    'nirvana_panels_distance_to_main_panel',
    'nirvana_panels_how_many',
  ],
  protection: ['protection_which'],
  can_light_new: [
    'can_light_new_how_many',
    'can_light_new_will_remove',
    'can_light_new_high_ceiling',
  ],
  ceiling_fan: ['ceiling_fan_detail'],
  construction_work: [],
  home_run: ['home_run_ft'],
  main_panel_upgrade:
    env.CODENAME === 'nirvana'
      ? ['main_panel_upgrade_rating']
      : [
          'main_panel_upgrade_installation_company',
          'main_panel_upgrade_needed_or_requested',
        ],
  derate: ['main_panel_upgrade_installation_company'],
  mini_split:
    env.CODENAME === 'nirvana'
      ? ['roof_shingles_or_tiles', 'mini_split_tons']
      : ['mini_split_tons'],
  smart_thermostat: ['smart_thermostat_how_many'],
  attic_fan: ['attic_fan_quantity'],
  pool_pump: [],
  duct_replacement: ['duct_replacement_qty'],
  duct_repair: ['duct_repair_quantity'],
  // Let us disable for now, for simplicity of the loan process
  // cash: ['cash_amount'],
  service_and_repair: ['service_and_repair_hours'],
  // solar_tax: [],
  small_system: [
    'main_panel_upgrade_installation_company',
    'small_system_size',
    'small_system_extra_batteries_will',
  ],
  flat_roof_panels: ['flat_roof_panels_how_many'],
  outlet: ['outlet_detail'],
  panel_removal: ['panel_removal_how_many'],
  // sub_panel_upgrade: [],
  // glow: ['glow_price_per_watt', 'glow_power_output_mw'],
  custom_fields: ['custom_fields_qty', 'custom_fields_name'],
  custom_two_fields: ['custom_two_fields_qty', 'custom_two_fields_name'],
  custom_three_fields: ['custom_three_fields_qty', 'custom_three_fields_name'],
  custom_four_fields: ['custom_four_fields_qty', 'custom_four_fields_name'],
  custom_five_fields: ['custom_five_fields_qty', 'custom_five_fields_name'],
  custom_six_fields: ['custom_six_fields_qty', 'custom_six_fields_name'],
  custom_seven_fields: ['custom_seven_fields_qty', 'custom_seven_fields_name'],
  custom_eight_fields: ['custom_eight_fields_qty', 'custom_eight_fields_name'],
  custom_nine_fields: ['custom_nine_fields_qty', 'custom_nine_fields_name'],
  custom_ten_fields: ['custom_ten_fields_qty', 'custom_ten_fields_name'],
}

// TODO: Do this via database
if (env.IS_WHITE_LABEL) {
  if (env.CODENAME === 'glow') {
    const allFields = utils.keys(adderToInputs)
    const nonGlowFields = allFields.filter(
      (field) => !schema.glowFields.includes(field),
    )
    for (const field of nonGlowFields) {
      delete adderToInputs[field]
    }
  } else if (env.CODENAME === 'nirvana') {
    const allFields = utils.keys(adderToInputs)
    const nonNirvanaFields = allFields.filter(
      (field) => !schema.nirvanaFields.includes(field),
    )
    for (const field of nonNirvanaFields) {
      delete adderToInputs[field]
    }
  } else {
    for (const field of schema.mainOnlyFields) {
      delete adderToInputs[field]
    }
  }
} else {
  for (const field of schema.nirvanaOnlyFields) {
    delete adderToInputs[field]
  }
  for (const [efficiency, inputs] of utils.entries(adderToInputs)) {
    ;(adderToInputs as Writable<typeof adderToInputs>)[efficiency] =
      inputs!.filter((input) => !schema.nirvanaOnlyFields.includes(input))
  }
}

export const inputToEfficiency: FieldToTrait<schema.CustomerField> = (() => {
  const res: Writable<FieldToTrait<schema.CustomerField>> = {}

  for (const [efficiency, inputs] of utils.entries(adderToInputs)) {
    for (const input of inputs!) res[input] = efficiency
    res[(efficiency + '_notes') as schema.CustomerField] = efficiency
    // res[efficiency] = efficiency
  }

  // @ts-ignore Typescript whack here
  for (const [input, [subInput]] of utils.entries(yesNoToDependent)) {
    // @ts-ignore Typescript whack here
    res[subInput] = res[input]
  }

  return res
})()

export const efficiencyKeys = utils.keys(adderToInputs)
export const nonCustomEfficiencyKeys = efficiencyKeys.filter(
  (k) => !k.startsWith('custom_'),
)

export const getFieldLabel = (
  field: keyof Customer,
  customer?: schema.Customer,
): string => {
  if (field === 'homeRep' && env.CODENAME === 'glow') {
    return 'Sales Representative'
  }
  if (field === 'roof_layers_how_many') {
    const roofingType = customer?.roof_layover_or_tear

    if (roofingType === schema.RoofWorkType.Layover) {
      return 'How many layers?'
    }
    if (roofingType === schema.RoofWorkType.ReRoofShingles) {
      return 'Current roof layers'
    }
    if (roofingType === schema.RoofWorkType.ReRoofFlatRoof) {
      return 'Current roof layers'
    }
    if (roofingType === schema.RoofWorkType.ReRoofWoodShake) {
      return 'Current roof layers'
    }
    return ''
  }

  if (field.startsWith('custom_')) {
    if (field.endsWith('_qty')) {
      return 'Qty'
    }
  }

  const maybeLabel = fieldToLabel[field]

  if (maybeLabel) return maybeLabel
  if (field.endsWith('customer_cost')) return 'Customer cost'
  if (field.endsWith('cost')) return 'Cost'
  if (field.endsWith('extra_notes')) return 'Extra notes'
  if (field.toLowerCase().includes('notes')) return 'Notes'
  return field
}

export const getMediaItemSrc = (mediaItem: MediaItem): string => {
  return mediaItem.status === 'uploaded'
    ? 'https://firebasestorage.googleapis.com/v0/b/' +
        env.commonEnv.FB_PROJECT_ID +
        '.' +
        env.commonEnv.FB_ST_BUCKET_SUFFIX +
        '/o/' +
        mediaItem.order_id +
        '%2F' +
        // TODO: thumbnail
        mediaItem.name +
        `?alt=media&token=dummy`
    : 'file://' + mediaItem.path
}

export const qualifyGlowPrimaryApplicantInputs: readonly schema.CustomerFields[] =
  [
    ['qualify_glow_first_name', 'qualify_glow_last_name'],
    ['qualify_glow_phone_number', 'qualify_glow_email'],
    ['qualify_glow_ssn', 'qualify_glow_birth_date'],
  ]

export const qualifyAddressInfoInputs: readonly schema.CustomerFields[] = [
  ['qualify_glow_street'],
  ['qualify_glow_city', 'qualify_glow_state', 'qualify_glow_zip'],
]

export const normalizeThumbnail = (
  customerID: string,
  thumbnail: string,
): string => {
  if (thumbnail === 'default_house.png') {
    return ''
  }
  if (thumbnail.length === 0) {
    return ''
  }
  if (thumbnail.startsWith('http')) {
    return thumbnail
  }
  if (thumbnail.startsWith('data:image/')) {
    return thumbnail
  }
  // Base64 jpg
  if (thumbnail.startsWith('/9j/')) {
    return 'data:image/jpeg;base64,' + thumbnail
  }
  // Base64 png
  if (thumbnail.startsWith('iVBO')) {
    return 'data:image/png;base64,' + thumbnail
  }

  return (
    'https://firebasestorage.googleapis.com/v0/b/' +
    env.commonEnv.FB_PROJECT_ID +
    '.' +
    env.commonEnv.FB_ST_BUCKET_SUFFIX +
    '/o/' +
    customerID +
    '%2F' +
    thumbnail +
    '?alt=media&token=69e431fa-59ad-497a-b700-a3aebcc68fc6'
  )
}

export const mediaToLabel: Partial<Record<MediaKind, string>> = {
  adders: 'Adjustment screenshots',
  electricity: 'Electricity bill',
  owner_house: 'House front view (showing address)',
  insulation: 'Attic',
  roof: 'Roof',
  windows: 'Windows',
  problem: 'Other areas',
  hvac_system: 'Hvac',
  id: 'ID picture',
  mini_split_surroundings: 'Mini split surroundings (wall & floor)',
  other_documents: 'Other documents',
  security_cam0: 'Cam angle #1',
  security_cam1: 'Cam angle #2',
  security_cam2: 'Cam angle #3',
  security_cam3: 'Cam angle #4',
  security_cam4: 'Cam angle #5',
  security_cam5: 'Cam angle #6',
  security_camera_locations: 'Camera Locations',
  security_doorbell_locations: 'Doorbell Locations',
  security_360_house_view: '360 House View',
  security_attic: 'Attic Access',
  security_router_location: 'Router Location',
  security_post_camera_installation: 'Post Camera Installation',
  security_post_alarm_installation: 'Post Alarm Installation',
  solar_proposal: 'Solar proposal',
}

type CategoryToMediaKinds = Readonly<Record<string, schema.MediaKinds>>
export const categoryToMediaKinds: CategoryToMediaKinds = {
  Assessment: [
    'insulation',
    'roof',
    'windows',
    'hvac_system',
    'mini_split_surroundings',
    'problem',
  ],
  Documentation: [
    'id',
    'electricity',
    'solar_proposal',
    'adders',
    'other_documents',
  ],
  Alarms: [
    'security_camera_locations',
    'security_doorbell_locations',
    'security_360_house_view',
    'security_attic',
    'security_router_location',
    'security_post_camera_installation',
    'security_post_alarm_installation',
  ],
}

if (env.IS_WHITE_LABEL) {
  if (env.CODENAME === 'glow') {
    const allKinds = utils.keys(mediaToLabel)
    const nonGlowKinds = allKinds.filter(
      (field) => !schema.glowMedia.includes(field),
    )
    for (const field of nonGlowKinds) {
      delete mediaToLabel[field]
    }
    for (const [category, kinds] of utils.entries(categoryToMediaKinds)) {
      ;(categoryToMediaKinds as Writable<CategoryToMediaKinds>)[category] =
        kinds.filter((k) => schema.glowMedia.includes(k))
    }
  } else if (env.CODENAME === 'nirvana') {
    const allKinds = utils.keys(mediaToLabel)
    const nonNirvanaKinds = allKinds.filter(
      (field) => !schema.nirvanaMedia.includes(field),
    )
    for (const field of nonNirvanaKinds) {
      delete mediaToLabel[field]
    }
    for (const [category, kinds] of utils.entries(categoryToMediaKinds)) {
      ;(categoryToMediaKinds as Writable<CategoryToMediaKinds>)[category] =
        kinds.filter((k) => schema.nirvanaMedia.includes(k))
    }
  } else {
    for (const mediaKind of schema.mainOnlyMedia) {
      delete mediaToLabel[mediaKind]
    }
  }
}

export const mediaToLabelSolarSurveyOld: Partial<Record<MediaKind, string>> = {
  thermal: 'Thermal camera',
  all_exterior_walls_site_survey: 'All exterior walls',
  rafters_site_survey: 'Rafters',
  all_planes_roof_site_survey: 'All planes roof',
  electrical: 'Electrical panel (do not use, old customers only)',
  other_site_survey: 'Other',
  electrical_panel_site_survey:
    'Electrical panel (do not use, old customers only)',
}
export const solarSurveyMediaKindsOld = utils.keys(mediaToLabelSolarSurveyOld)
export const mediaToLabelSolarSurveyNew: Partial<Record<MediaKind, string>> = {
  thermal: 'Thermal camera',
  all_exterior_walls_site_survey: 'All exterior walls',
  rafters_site_survey: 'Rafters',
  all_planes_roof_site_survey: 'All planes roof',
  main_service_panel_site_survey: 'Main service panel',
  eight_foot_msp_site_survey: '8 foot msp',
  utility_meter_closeup_site_survey: 'Utility meter close up',
  main_panel_label_site_survey: 'Main panel label',
  main_panel_breakers_dead_front_included_site_survey:
    'All breakers labeled on lid',
  main_panel_breakers_dead_front_removed_site_survey:
    'All breakers with lid removed',
  main_breaker_disconnect_closeup_site_survey: 'Main breaker',
  ground_system_connected_site_survey: 'Grounding (if visible)',
  sub_panels_site_survey: 'Sub-panel(s) (if any)',
  existing_solar_system_site_survey: 'Existing solar system (if any)',
  all_appliances_and_labels_site_survey: 'All appliances and labels',
  other_site_survey: 'Other',
}
export const solarSurveyMediaKindsNew = utils.keys(mediaToLabelSolarSurveyNew)

export const mediaToLabelRoofClaims: Partial<Record<MediaKind, string>> = {
  rc_front_house: 'Front of the house',
  rc_address_verification: 'Address verification',
  rc_3d_view: '3D view',
  rc_garage: 'Garage',
  rc_wires_home: 'Wires in to home',
  rc_siding: 'Siding',
  rc_layers: 'Shingle layers',
  rc_roof_inclination: 'Roof inclination angle',
  rc_roof_overview: 'Roof overview',
  rc_drip_edge: 'Drip edge',
  rc_gutters: 'Gutters',
  rc_ice_shield: 'Ice shield',
  rc_flashings: 'Flashings',
  rc_penetrations: 'Penetrations',
  rc_hail: 'Hail damages',
  rc_other_property_wind_damage: 'Property damages',
  rc_wind_damages: 'Wind damages',
  rc_length_shingle: 'Shingle length',
  rc_shingles_color: 'Shingles color',
}

export const roofClaimsMediaKinds = utils.keys(mediaToLabelRoofClaims)

export const checkAllRoofFilled = (customer: schema.Customer): boolean => {
  const isNewerCustomer = customer.createdAt > jan302025
  const roofPitchEmpty = isNewerCustomer && customer.roof_pitch === ''
  if (customer.roof_layover_or_tear === '') {
    return false
  }
  if (customer.roof_layover_or_tear === schema.RoofWorkType.Layover) {
    if (
      customer.roof_square_footage === '' ||
      roofPitchEmpty ||
      customer.roof_layers_how_many === ''
    ) {
      return false
    }
  } else if (
    customer.roof_layover_or_tear === schema.RoofWorkType.ReRoofFlatRoof
  ) {
    if (
      customer.roof_square_footage === '' ||
      roofPitchEmpty ||
      customer.roof_layers_how_many === ''
    ) {
      return false
    }
  } else if (
    customer.roof_layover_or_tear === schema.RoofWorkType.ReRoofShingles
  ) {
    if (
      customer.roof_square_footage === '' ||
      roofPitchEmpty ||
      customer.roof_layers_how_many === '' ||
      customer.roof_tear_material === ''
    ) {
      return false
    }
  } else if (
    customer.roof_layover_or_tear === schema.RoofWorkType.ReRoofWoodShake
  ) {
    if (
      customer.roof_square_footage === '' ||
      roofPitchEmpty ||
      customer.roof_layers_how_many === '' ||
      customer.roof_tear_material === ''
    ) {
      return false
    }
  } else if (customer.roof_layover_or_tear === schema.RoofWorkType.TileRepl) {
    if (customer.roof_square_footage === '' || roofPitchEmpty) {
      return false
    }
  } else if (
    customer.roof_layover_or_tear === schema.RoofWorkType.UnderlaymentRepl
  ) {
    if (customer.roof_square_footage === '' || roofPitchEmpty) {
      return false
    }
  } else {
    console.error('Roof work type un-accounted for in checkAllRoofFilled()')
  }
  return true
}

export type Guideline = utils.r<{
  type: 'error' | 'info' | 'warning'
  text: string
}>

const roofFillAllFieldsGuideline: Guideline = {
  text: 'Fill all fields',
  type: 'warning',
}

export const getFieldGuideline = (
  customer: schema.Customer,
  field: schema.CustomerField,
): Guideline | null => {
  const installer = customer?.main_panel_upgrade_installation_company
  const noInstaller = installer === 'To Be Decided' || !installer

  if (field === 'air_conditioner_new_tons') {
    if (
      customer.air_conditioner_working === 'yes' &&
      customer.air_conditioner_unit_type.startsWith('split_') &&
      customer.air_conditioner_furnance === 'no'
    ) {
      if (!customer.air_conditioner_current_tons) {
        return {
          text: 'Select current AC tons',
          type: 'warning',
        }
      }
      return {
        text: 'Match preferred if no furnance',
        type: 'info',
      }
    }

    if (customer.attic_square_footage) {
      return {
        type: 'info',
        text: `Recommended tons = ${Math.round(
          utils.parseFloating(customer.attic_square_footage) / 400,
        )}`,
      }
    } else {
      return {
        type: 'warning',
        text: 'Enter attic square footage to get recommended tons',
      }
    }
  }
  if (
    field === 'roof_layers_how_many' &&
    customer.roof_layover_or_tear === 'Layover' &&
    utils.parseInt(customer.roof_layers_how_many) > 2
  ) {
    return {
      type: 'warning',
      text: 'For more than 2 layers you need to do a shingles re roof',
    }
  }
  if (field === 'roof_pitch') {
    if (customer.roof_layover_or_tear === schema.RoofWorkType.ReRoofFlatRoof) {
      if (utils.parseInt(customer.roof_pitch) > 1) {
        return {
          text: 'Not a flat roof?',
          type: 'error',
        }
      }
      return null
    }
    return {
      text: 'Will incur a fee if higher than 7',
      type: 'info',
    }
  }
  if (field === 'battery_size') {
    if (noInstaller) {
      return {
        text: 'Installer not selected',
        type: 'warning',
      }
    }
    if (customer?.main_panel_upgrade_installation_company === 'EcoManagement') {
      return {
        type: 'info',
        text: 'Battery size should be bigger than the system. Promo only applies to utility companies: SCE/PG&E/SDG&E',
      }
    }
    return {
      type: 'info',
      text: 'Battery size should be bigger than the system',
    }
  }
  if (field === 'battery_cost') {
    const batteryTypeSelected = !!customer.battery_type

    if (batteryTypeSelected && noInstaller) {
      return { text: 'Installer not selected', type: 'warning' }
    }
  }
  if (field === 'battery_type') {
    if (noInstaller) {
      return { text: 'Installer not selected', type: 'warning' }
    }
  }
  if (field === 'derate_cost') {
    if (noInstaller) {
      return { text: 'Installer not selected', type: 'warning' }
    }
  }
  if (field === 'main_panel_upgrade_cost') {
    if (noInstaller) {
      return { text: 'Installer not selected', type: 'warning' }
    }
  }
  if (field === 'main_panel_upgrade_installation_company') {
    if (!customer.products.includes('Solar')) {
      return { text: 'Turn on Solar in Customer Info', type: 'warning' }
    }
  }
  if (field === 'main_panel_upgrade_needed_or_requested') {
    if (noInstaller) {
      return { text: 'Installer not selected', type: 'warning' }
    }
  }
  if (field === 'roof_cost') {
    if (!checkAllRoofFilled(customer)) {
      return roofFillAllFieldsGuideline
    }
  }
  if (field === 'roof_commission_add_up') {
    if (utils.parseFloating(customer.roof_commission_add_up) > 3000) {
      return { text: 'Must be 3000 or lower', type: 'error' }
    }
  }
  if (field === 'small_system_cost') {
    if (noInstaller) {
      return { text: 'Installer not selected', type: 'warning' }
    }
  }

  return null
}

export const disableInputs: FieldToTrait<boolean> = {
  cash_cost: true,
  createdAt: true,
  date: true,
  sort_key: true,
}

/**
 * If an efficiency is disabled, the disabled should cascade down to all
 * non-notes inputs
 */
export const shouldDisableInput = (
  field: schema.CustomerField,
  customer: schema.Customer,
): boolean => {
  if (adderToInputs[field] && customer.payment_is_applied) {
    return true
  }

  if (field === 'air_conditioner_new_tons') {
    return (
      customer.air_conditioner_working === 'yes' &&
      customer.air_conditioner_unit_type.startsWith('split_') &&
      customer.air_conditioner_furnance === 'no'
    )
  }
  if (field === 'security_alarm_payout') {
    return customer.payment_is_applied
  }
  if (field === 'cash_cost' || field === 'cash_customer_cost') {
    return true
  }
  if (field === 'homeStoryNumber') {
    return customer.payment_is_applied
  }
  if (field === 'main_panel_upgrade_installation_company') {
    return !customer.products.includes('Solar')
  }
  if (
    field === 'main_panel_upgrade_needed_or_requested' &&
    !customer.main_panel_upgrade_installation_company
  ) {
    return true
  }

  if (field.endsWith('notes') && !field.endsWith('extra_notes')) {
    const efficiency = fieldToEfficiency(field)
    return !!efficiencyToCalculator[efficiency!]
  }
  return Boolean(disableInputs[field])
}

export const shouldEnableInput = (
  field: schema.CustomerField,
  customer: schema.Customer,
): boolean => !shouldDisableInput(field, customer)

export const parseCashbackOptions = (options: string): utils.Opts => {
  try {
    const _options = JSON.parse(options) as unknown as utils.Opts

    return _options
  } catch (e) {
    return []
  }
}

export const getTotalCashback = (options: utils.Opts, customer: Customer) => {
  let total = 0

  if (options.length) {
    options.forEach((key) => {
      if (customer[key.value as keyof Customer]) {
        total += utils.parseFloating(
          customer[key.value as keyof Customer] as string,
        )
      }
    })
  }
  return total
}

export const fieldToEfficiency = (
  field: schema.CustomerField,
): schema.CustomerField | undefined => {
  if (field.endsWith('_cost')) {
    return field.replace('_cost', '') as schema.CustomerField
  }
  if (field.endsWith('_customer_cost')) {
    return field.replace('_customer_cost', '') as schema.CustomerField
  }
  if (field.endsWith('_notes')) {
    return field.replace('_notes', '') as schema.CustomerField
  }
  if (field.endsWith('_extra_notes')) {
    return field.replace('_extra_notes', '') as schema.CustomerField
  }
  const [efficiencyField] =
    utils
      .entries(adderToInputs)
      .find(([_, subFields]) =>
        [subFields].flat(1).some((v) => v?.includes(field)),
      ) || []

  return efficiencyField
}

export const isSubField = (field: keyof Customer) => {
  let isSubfield = false
  efficiencyKeys.forEach((key) => {
    if (field?.startsWith(key) && field !== key && !field.endsWith('notes')) {
      isSubfield = true
    }
  })

  return isSubfield
}

export const fieldCanBeEmpty = (field: schema.CustomerField) => {
  if (isSubField(field)) {
    return true
  }

  // TODO: Later to be handled by the new schema validators
  return ['customerPhoneAlt', 'ssn'].includes(field)
}

export const fieldShouldBeFilled = (field: schema.CustomerField): boolean =>
  !fieldCanBeEmpty(field)

export const isLargeEfficiency = (field: keyof Customer) => {
  if (
    field === 'air_conditioner' ||
    field === 'attic_insulation' ||
    field === 'new_windows' ||
    field === 'roof'
  ) {
    return true
  }

  return false
}

//#region MPUCalculator

const MAX_PANELS = 42

interface Inverter {
  readonly capacity: number
  readonly name: string
  readonly numOfPanels: readonly [lowerBound: number, upperBound: number]
}

const availableInverters: readonly Inverter[] = [
  {
    capacity: 1.21,
    name: 'Enphase IQ8+ Microinverters.',
    numOfPanels: [1, 1],
  },
  {
    capacity: 2.42,
    name: '2 x Enphase IQ8+ Microinverters.',
    numOfPanels: [2, 2],
  },
  {
    capacity: 3.63,
    name: '3 x Enphase IQ8+ Microinverters.',
    numOfPanels: [3, 3],
  },
  {
    capacity: 4.84,
    name: '4 x Enphase IQ8+ Microinverters.',
    numOfPanels: [4, 4],
  },
  {
    capacity: 6.05,
    name: '5 x Enphase IQ8+ Microinverters.',
    numOfPanels: [5, 5],
  },
  {
    capacity: 7.26,
    name: '6 x Enphase IQ8+ Microinverters.',
    numOfPanels: [6, 6],
  },
  {
    capacity: 8.47,
    name: '7 x Enphase IQ8+ Microinverters.',
    numOfPanels: [7, 7],
  },
  {
    capacity: 16,
    name: 'Solaredge Inv-3800',
    numOfPanels: [8, 12],
  },
  {
    capacity: 21,
    name: 'Solaredge Inv-5000',
    numOfPanels: [13, 16],
  },
  {
    capacity: 25,
    name: 'Solaredge Inv-6000',
    numOfPanels: [17, 20],
  },
  {
    capacity: 32,
    name: 'Solaredge Inv-7600',
    numOfPanels: [21, 25],
  },
  {
    capacity: 40,
    name: 'Solaredge Inv-10000',
    numOfPanels: [26, 33],
  },
  {
    capacity: 47.5,
    name: 'Solaredge Inv-11400',
    numOfPanels: [34, 38],
  },
  {
    capacity: 50,
    name: 'Solaredge Inv-6000 + Solaredge Inv-6000',
    numOfPanels: [39, 40],
  },
  {
    capacity: 53,
    name: 'Solaredge Inv-7600 + Solaredge Inv 5000',
    numOfPanels: [41, 42],
  },
]

const reverseInverters = availableInverters.slice().reverse()

interface MPU {
  readonly capacity: number
  readonly name: string
}

const availableMPUs: readonly MPU[] = [
  {
    capacity: 225,
    name: '225amp MPU',
  },
]

const [maxCapInverter] = (availableMPUs as [Inverter])
  .slice()
  .sort((a, b) => a.capacity - b.capacity)

export const { capacity: MAX_MPU_RATING } = maxCapInverter!

export interface MPUCalculatorResult {
  readonly maxPanelsAsIs: number | null
  readonly maxPanelsWithDerate: number | null
  readonly inverterAsIs: Inverter | null
  readonly inverterWithDerate: Inverter | null
}

const VALID_DERATES = [100, 175, 200]

export const mpuCalculator = (
  busRating: number,
  mainBreakerRating: number,
): MPUCalculatorResult => {
  const res: Writable<MPUCalculatorResult> = {
    maxPanelsAsIs: null,
    maxPanelsWithDerate: null,
    inverterAsIs: null,
    inverterWithDerate: null,
  }

  // Information!G11 = numOfPanels

  // Information!F15 = chosenInverter according to numOfPanels
  // Information!K15 = chosenInverter.capacity * 1.25

  for (const inverter of reverseInverters) {
    const {
      capacity,
      numOfPanels: [, upperBound],
    } = inverter
    /**
     * IF (B2*1.2)>B3+(Information!C48*1.25):
     *   CONCATENATE("Maximum number of Solar Panels possible to install without the need of Derate or MPU: ",Information!A48),
     * else:
     *   IF (B2*1.2)>B3+(Information!C46*1.25):
     *      CONCATENATE("Maximum number of Solar Panels possible to install without the need of Derate or MPU: ",Information!A46)
     *   else:
     *     IF (B2*1.2)>B3+(Information!C44*1.25):
     *       CONCATENATE("Maximum number of Solar Panels possible to install without the need of Derate or MPU: ",Information!A44)
     *     else:
     *       IF (B2*1.2)>B3+(Information!C39*1.25):
     *         CONCATENATE("Maximum number of Solar Panels possible to install without the need of Derate or MPU: ",Information!A39)
     *       else:
     *         IF (B2*1.2)>B3+(Information!C31*1.25):
     *           CONCATENATE("Maximum number of Solar Panels possible to install without the need of Derate or MPU: ",Information!A31)
     *         else:
     *           IF (B2*1.2)>B3+(Information!C26*1.25):
     *             CONCATENATE("Maximum number of Solar Panels possible to install without the need of Derate or MPU: ",Information!A26)
     *           else:
     *             IF (B2*1.2)>B3+(Information!C21*1.25):
     *               CONCATENATE("Maximum number of Solar Panels possible to install without the need of Derate or MPU: ",Information!A21)
     *             else:
     *               IF (B2*1.2)>B3+(Information!C18*1.25):
     *                 CONCATENATE("Maximum number of Solar Panels possible to install without the need of Derate or MPU: ",Information!A18),"No possible to install Solar Panels without the need of Derate or MPU"))))))))
     */
    if (busRating * 1.2 > mainBreakerRating + capacity * 1.25) {
      res.maxPanelsAsIs = upperBound
      res.inverterAsIs = inverter
      break
    }
  }

  if (!res.maxPanelsAsIs || !res.inverterAsIs) {
    return res
  }

  for (const numOfPanels of range(
    MAX_PANELS - res.maxPanelsAsIs,
    res.maxPanelsAsIs + 1,
  )) {
    /**
     * IF (B2*1.2)>B3+Information!K15:
     *   "Derate is not need"
     * else IF (B2*1.2)>B3-25+Information!K15:
     *   IF B3-25=200:
     *     CONCATENATE("Derate size should be: ",B3-25)
     *   else IF B3-25=175:
     *     CONCATENATE("Derate size should be: ",B3-25,)
     *   else IF B3-25=100:
     *     CONCATENATE("Derate size should be: ",B3-25,)
     *   else:
     *    "Derate is not possible"
     * else:
     *   "Derate is not possible"
     */
    const inverterViaPanels = availableInverters.find(
      ({ numOfPanels: [lowerBound, upperBound] }) =>
        isBetween({
          lowerBound,
          upperBound,
          value: numOfPanels,
        }),
    )
    if (!inverterViaPanels) {
      return res
    }
    if (
      busRating * 1.2 >
      mainBreakerRating + inverterViaPanels.capacity * 1.25
    ) {
      // Derate not needed
      if (numOfPanels !== res.maxPanelsAsIs) {
        console.error('Assertion failed: numOfPanels === res.maxPanelsAsIs')
      }
      continue
    }

    if (
      busRating * 1.2 >
      mainBreakerRating - 25 + inverterViaPanels.capacity * 1.25
    ) {
      /**
       * IF B3-25=200:
       *     CONCATENATE("Derate size should be: ",B3-25)
       *   else IF B3-25=175:
       *     CONCATENATE("Derate size should be: ",B3-25,)
       *   else IF B3-25=100:
       *     CONCATENATE("Derate size should be: ",B3-25,)
       *   else:
       *    "Derate is not possible"
       */
      if (VALID_DERATES.includes(mainBreakerRating - 25)) {
        res.maxPanelsWithDerate = numOfPanels
        const inverterViaPanels = availableInverters.find(
          ({ numOfPanels: [lowerBound, upperBound] }) =>
            isBetween({
              lowerBound,
              upperBound,
              value: numOfPanels,
            }),
        )
        if (!inverterViaPanels) {
          console.error(
            `Found panels with derate but not Inverter for those panels?`,
          )
          continue
        }
        res.inverterWithDerate = inverterViaPanels
      }
    }
  }

  return res
}

// TODO: Move to react utils
export function useMpuCalculator() {
  const [mpuBusRating, setMpuBusRating] = React.useState('')
  const [mpuMainBreakerRating, setMPUMainBreakerRating] = React.useState('')

  const mpuCalculatorResult = React.useMemo((): MPUCalculatorResult | null => {
    if ([mpuBusRating, mpuBusRating].every(stringIsInt)) {
      // const parsedNumOfSolarPanels = parseInt(numOfSolarPanels, 10)
      const parsedMPUBusRating = utils.parseFloating(mpuBusRating)
      const parsedMPUMainBreakerRating =
        utils.parseFloating(mpuMainBreakerRating)

      return mpuCalculator(parsedMPUBusRating, parsedMPUMainBreakerRating)
    }

    return null
  }, [mpuBusRating, mpuMainBreakerRating])

  return {
    mpuBusRating,
    mpuCalculatorResult,
    mpuMainBreakerRating,
    setMpuBusRating,
    setMPUMainBreakerRating,
  }
}

//#endregion MPUCalculator

export const invoiceEfficiencyOpts: utils.DeepReadonly<
  Record<string, string[] | Record<string, string[]>>
> = {
  artificial_turf: [
    'Evergreen Collection Waterproof Solid Grass 1x1 Indoor/Outdoor Artificial Grass Tile, 1 ft. x 1 ft',
  ],
  attic_insulation: ['Attic Insulation'],
  duct_seal: ['Duct Seal'],
  efficient_boiler: [
    'Rinnai M120SN Condensing Gas Boiler, Natural Gas: Materials+Labor',
    'Aspen Firetube 126,000 BTU Combi High Efficiency Wall Hung Condensing Gas Fired Boiler: Materials+Labor',
  ],
  heat_pump: [
    'Goodman 5 Ton 15.5 SEER Heat Pump GSZC180601, Coil CHPF4860D6, 120,000 BTU 97% AFUE Horizontal Gas furnance GMVM971205DN',
    '56,000 BTU 4.6 Ton 17.5 SEER Ducted Central Split Air Conditioner Heat Pump System',
  ],
  hvac: [
    '2 T HVAC System Installation: Miscellaneous + Labor',
    '2.5 T HVAC System Installation: Miscellaneous + Labor',
    '3 T HVAC System Installation: Miscellaneous + Labor',
    '3.5 T HVAC System Installation: Miscellaneous + Labor',
    '4 T HVAC System Installation: Miscellaneous + Labor',
    '5 T HVAC System Installation: Miscellaneous + Labor',
  ],
  mini_split: [
    '1T HVAC mini split: Miscellaneous+Labor',
    '2T HVAC mini split: Miscellaneous+Labor',
  ],
  radiant_floor: ['WarmlyYours Tempzone Electric Radiant Floor  '],
  roof: {
    roof_layover: [
      'Install 30-year Shingles according to manufactures specifications\nSeal penetrations',
    ],
    shingles_tear_off: [
      'Tear off the existing roof.\nInstall one-layer of synthetic underlayment.\nInstall new 2x2 drep edge metal.\nInstall 30-year Shingles according to manufactures specifications.\nSeal penetrations.\n',
    ],
  },
  thermostat: [
    'Ecobee3 Lite Programmable Smart Thermostat - Energy Star Certified',
    'Nest Learning Thermostat - Smart Wi-Fi Thermostat Stainless Steel',
  ],
  whole_house_fans: [
    'Whole House Fan/Ventilation',
    'QA-Deluxe 6500 Includes Plug & Play Wireless On/Off Remote Control | Energy Efficient Whole House Fan | R-5 Insulated Damper',
  ],
  windows: ['Sliding Windows', 'Sliding Windows: Low-E Energy Efficient.'],
  windows_film: [
    'KESPEN Window Privacy Film One Way Daytime Privacy Static Cling Sun Blocking Anti UV Reflective Window Tint for Home and Office, Black-Silver',
  ],
}

/**
 * At this point this is just the state for the company.
 */
export const companyToLabel: utils.ReadonlyRecord<string> = (() => {
  const res: Record<string, string> = {}

  for (const [subCompanyLabel, subCompanyValue] of utils.zip(
    env.COMPANY_LABELS,
    env.COMPANY_VALUES,
  ) as readonly [string, string][]) {
    res[subCompanyValue] = subCompanyLabel
  }

  return res
})()

export const stateToSolarCompanyName: utils.ReadonlyRecord<string> = {
  california: 'California Power Solutions',
  nevada: 'Nevada Power Solutions',
}

//#region Glow
const nper = 10 // Commitment (years)
const pmt = 0 // Payment amount per period

const calcAvg = (rate: number, value: number): number => {
  const pv =
    (value * (1 - Math.pow(1 + rate, -nper))) / rate -
    (pmt * (1 - Math.pow(1 + rate, -nper))) / rate
  return Number(pv.toFixed(2))
}

const cashFlowDiscount = 0.11 // Cashflow discount
const _powerOutputMW = 0.0156

export const calculateProtocolFee = (
  pricePerWatt: number,
  hoursOfSunPerDay: number,
  escalator: number,
  powerOutputMW: number = _powerOutputMW,
): number => {
  const firstYearElectricityOldPrice = Number(
    (pricePerWatt * hoursOfSunPerDay * powerOutputMW * 365.25).toFixed(2),
  )

  const lifetimeOldElectricityValue = calcAvg(
    -escalator,
    firstYearElectricityOldPrice,
  )

  const protocolCashRequirements = calcAvg(
    cashFlowDiscount,
    lifetimeOldElectricityValue / nper,
  )

  return protocolCashRequirements
}

export const calculateInstallationCost = (
  installationCostPerWatt: number,
  powerOutputMW: number = _powerOutputMW,
): number => {
  return installationCostPerWatt * powerOutputMW * 1000000
}
//#endregion Glow

/**
 * Windows global color selectors cut-off.
 */
export const Jun4_2024 = 1717519937085
/**
 * Roof pitch cut off
 */
const jan302025 = 1738238982375
export const shouldHideInput = (
  field: schema.CustomerField,
  customer: schema.Customer,
): boolean => {
  const state = env.getCompanyState(customer.solarCompany)

  const dependency = fieldToDependency[field]
  if (dependency) {
    /* Special case */
    if (field === 'new_windows_replace_custom') {
      return customer.new_windows_replace !== 'no'
    }
    return customer[dependency] !== 'yes'
  }

  //#region efficiencies
  const { products: currProducts } = customer
  if (field === 'security_cams') {
    const shouldShow = currProducts.includes('Security') || currProducts === ''
    return !shouldShow
  }
  if (field === 'security_system') {
    const shouldShow = currProducts.includes('Security') || currProducts === ''
    return !shouldShow
  }
  if (field === 'security_tv') {
    const shouldShow = currProducts.includes('Security') || currProducts === ''
    return !shouldShow
  }
  if (field === 'security_wifi_cameras') {
    const shouldShow = currProducts.includes('Security') || currProducts === ''
    return !shouldShow
  }
  if (field === 'attic_insulation') {
    const shouldShow = currProducts.includes('HIL') || currProducts === ''
    return !shouldShow
  }
  if (field === 'duct_seal') {
    const shouldShow = currProducts.includes('HIL') || currProducts === ''
    return !shouldShow
  }
  if (field === 'inverter_swap') {
    const shouldShow = currProducts.includes('Solar') || currProducts === ''
    return !shouldShow
  }
  if (field === 'roof') {
    const shouldShow = currProducts.includes('HIL') || currProducts === ''
    return !shouldShow
  }
  if (field === 'new_windows') {
    const shouldShow = currProducts.includes('HIL') || currProducts === ''
    return !shouldShow
  }
  if (field === 'air_conditioner') {
    const shouldShow = currProducts.includes('HIL') || currProducts === ''
    return !shouldShow
  }
  if (field === 'battery') {
    const shouldShow = currProducts.includes('Solar') || currProducts !== ''
    if (!customer.solarCompany) return true
    // Nirvana in AZ uses battery_multiple
    if (state !== 'california') return true
    return !shouldShow
  }
  if (field === 'can_light_new') {
    const shouldShow = currProducts.includes('HIL') || currProducts === ''
    return !shouldShow
  }
  if (field === 'ceiling_fan') {
    const shouldShow = currProducts.includes('HIL') || currProducts === ''
    return !shouldShow
  }
  if (field === 'construction_work') {
    const shouldShow = currProducts.includes('HIL') || currProducts === ''
    return !shouldShow
  }
  if (field === 'home_run') {
    const shouldShow = currProducts.includes('HIL') || currProducts === ''
    return !shouldShow
  }
  if (field === 'main_panel_upgrade') {
    const shouldShow = currProducts.includes('HIL') || currProducts === ''
    return !shouldShow
  }
  if (field === 'derate') {
    const shouldShow = currProducts.includes('Solar') || currProducts === ''
    return !shouldShow
  }
  if (field === 'mini_split') {
    const shouldShow = currProducts.includes('HIL') || currProducts === ''
    return !shouldShow
  }
  if (field === 'smart_thermostat') {
    const shouldShow = currProducts.includes('HIL') || currProducts === ''
    return !shouldShow
  }
  if (field === 'attic_fan') {
    const shouldShow = currProducts.includes('HIL') || currProducts === ''
    return !shouldShow
  }
  if (field === 'pool_pump') {
    const shouldShow = currProducts.includes('HIL') || currProducts === ''
    return !shouldShow
  }
  if (field === 'duct_replacement') {
    const shouldShow = currProducts.includes('HIL') || currProducts === ''
    return !shouldShow
  }
  if (field === 'duct_repair') {
    const shouldShow = currProducts.includes('HIL') || currProducts === ''
    return !shouldShow
  }
  if (field === 'cash') {
    const shouldShow = currProducts.includes('HIL') || currProducts === ''
    return !shouldShow
  }
  if (field === 'service_and_repair') {
    const shouldShow = currProducts.includes('HIL') || currProducts === ''
    return !shouldShow
  }
  if (field === 'solar_tax') {
    const shouldShow = currProducts.includes('Solar') || currProducts === ''
    return !shouldShow
  }
  if (field === 'small_system') {
    const shouldShow = currProducts.includes('Solar') || currProducts === ''
    return !shouldShow
  }
  if (field === 'flat_roof_panels') {
    const shouldShow = currProducts.includes('Solar') || currProducts === ''
    return !shouldShow
  }
  if (field === 'panel_removal') {
    const shouldShow = currProducts.includes('HIL') || currProducts === ''
    return !shouldShow
  }
  //#endregion efficiencies

  if (field === 'air_conditioner_current_tons') {
    return customer.air_conditioner_working !== 'yes'
  }
  if (field === 'air_conditioner_furnance') {
    return (
      customer.air_conditioner_working === 'no' ||
      !customer.air_conditioner_unit_type.startsWith('split_')
    )
  }
  if (field === 'air_conditioner_swamp_cooler_use_remove') {
    return customer.air_conditioner_swamp_cooler_use !== 'yes'
  }
  if (field === 'air_conditioner_replace_ducts') {
    return customer.air_conditioner_working === 'no'
  }
  if (field === 'battery_size') {
    return customer.battery_type.toLowerCase() === ''
  }
  if (field === 'can_light_new_will_remove_how_many') {
    return customer.can_light_new_will_remove !== 'yes'
  }
  if (field === 'glow') {
    const shouldDisplay = env.IS_MAIN || env.CODENAME === 'glow'
    const shouldHide = !shouldDisplay
    return shouldHide
  }
  if (field === 'main_panel_upgrade_installation_company') {
    return env.CODENAME === 'nirvana'
  }
  // Hide for older customers
  if (field === 'new_windows_color') {
    return utils.normalizeTimestampToMs(customer.createdAt) < Jun4_2024
  }
  if (field === 'new_windows_sliding_glass_sqft') {
    return customer.new_windows_sliding_glass !== 'yes'
  }
  if (field === 'roof_shingles_or_tiles') {
    return env.CODENAME !== 'nirvana'
  }
  if (field === 'roof_fascia_included_square_footage') {
    return customer.roof_fascia_included !== 'yes'
  }
  if (field === 'roof_layers_how_many') {
    const shouldShow =
      customer.roof_layover_or_tear === schema.RoofWorkType.ReRoofShingles ||
      customer.roof_layover_or_tear === schema.RoofWorkType.Layover ||
      customer.roof_layover_or_tear === schema.RoofWorkType.ReRoofFlatRoof ||
      customer.roof_layover_or_tear === schema.RoofWorkType.ReRoofWoodShake

    return !shouldShow
  }
  if (field === 'roof_patio_included') {
    return customer.roof_layover_or_tear === schema.RoofWorkType.ReRoofFlatRoof
  }
  if (field === 'roof_patio_how_many') {
    return customer.roof_patio_included !== 'yes'
  }
  if (field === 'roof_pitch') {
    return customer.createdAt < jan302025
  }
  if (field === 'roof_plywood_replaced') {
    if (customer.roof_layover_or_tear === schema.RoofWorkType.TileRepl) {
      return customer.roof_plywood_under_tile === 'no'
    }
    return customer.roof_layover_or_tear === schema.RoofWorkType.Layover
  }
  if (field === 'roof_plywood_under_tile') {
    return customer.roof_layover_or_tear !== schema.RoofWorkType.TileRepl
  }
  if (field === 'roof_plywood_replaced_square') {
    return customer.roof_plywood_replaced !== 'yes'
  }
  if (field === 'roof_tear_material') {
    return (
      customer.roof_layover_or_tear !== schema.RoofWorkType.ReRoofShingles &&
      customer.roof_layover_or_tear !== schema.RoofWorkType.ReRoofWoodShake
    )
  }
  if (field === 'roof_will_add_license') {
    return state !== 'california'
  }
  if (field === 'roof_commission_add_up') {
    return state !== 'california'
  }

  return false
}

export const shouldDisplayInput = (
  field: schema.CustomerField,
  customer: schema.Customer,
): boolean => !shouldHideInput(field, customer)

export const fieldToGrow: FieldToTrait<boolean> = {
  air_conditioner_furnance: true,

  customerAddress: true,

  cash_air_conditioner: true,
  cash_artificial_turf: true,
  cash_amount: true,
  cash_irrigation_systems: true,
  cash_heat_pumps: true,
  cash_whole_house_fans_or_ventilation: true,
  cash_efficient_boilers: true,
  cash_geothermal_heat_pumps: true,
  cash_radiant_floors: true,
  cash_water_saving_fixtures: true,
  cash_solar_water_heaters: true,
  cash_on_demand_or_tankless_hot: true,
  cash_windows: true,
  cash_floor_insulation: true,
  cash_efficient_water_heaters: true,
  cash_pool_pumps: true,

  globalNotes: true,

  new_windows_color: true,
  new_windows_replace: true,
  new_windows_replace_custom: true,
  new_windows_grid: true,
  new_windows_sliding_glass: true,
  new_windows_sqft_each_window: true,

  nirvana_panels_panel_scenario: true,

  custom_fields_name: true,
  custom_two_fields_name: true,
  custom_three_fields_name: true,
  custom_four_fields_name: true,
  custom_five_fields_name: true,
  custom_six_fields_name: true,
  custom_seven_fields_name: true,
  custom_eight_fields_name: true,
  custom_nine_fields_name: true,
  custom_ten_fields_name: true,

  roof_will_add_license: true,
}

export const readableDateFormat = 'MMM Do YYYY'
export const readableDateFormatWTime = 'MMM Do YYYY HH:MM'

type Calculator = (
  customer: utils.DeepReadonly<schema.Customer>,
  prices: utils.DeepReadonly<schema.SaleTag>,
  state: 'arizona' | 'california' | 'nevada',
) => [number, string]

const defaultMiniSplitCalculator: Calculator = (
  { mini_split_tons },
  prices,
  state,
) => {
  let finalCost = 0
  const notesLines: string[] = []

  const [miniSplitTon1Price, miniSplitTon2Price] = (() => {
    const priceList =
      state === 'california'
        ? prices.mini_split.california.pricesByCity[0]!.list
        : prices.mini_split[state].list

    return [
      priceList.find((cp) => cp.label === 'Mini Split System 1Ton')!.value,
      priceList.find((cp) => cp.label === 'Mini Split System 2Ton')!.value,
    ]
  })()

  const miniSplits = JSON.parse(mini_split_tons || '[]') as schema.MiniSplit[]

  for (const split of miniSplits.filter((ms) => ms.qty && ms.tons)) {
    if (
      // @ts-ignore
      split.tons === '1' ||
      split.tons === 'mini_split_1t' ||
      // @ts-ignore Old data
      split.tons === 1
    ) {
      finalCost += utils.parseInteger(split.qty) * miniSplitTon1Price
    }
    if (
      // @ts-ignore
      split.tons === '2' ||
      split.tons === 'mini_split_2t' ||
      // @ts-ignore Old data
      split.tons === 2
    ) {
      finalCost += utils.parseInteger(split.qty) * miniSplitTon2Price
    }
  }

  return [finalCost, notesLines.join('\n')]
}

const nirvanaMiniSplitCalculator: Calculator = (
  { mini_split_tons, roof_shingles_or_tiles },
  prices,
  state,
) => {
  let finalCost = 0
  const notesLines: string[] = []

  const priceList =
    state === 'california'
      ? prices.mini_split.california.pricesByCity[0]!.list
      : prices.mini_split[state].list

  const [
    miniSplitInstallFee,

    mini_split_price_12kBTU,
    mini_split_price_18kBTU,
    mini_split_price_24kBTU,

    mini_split_price_dualHead_24kBTU,
    miniSplitInstallFeeDualHead,

    wiringPrice,
    conduitPrice,
  ] = (() => {
    return [
      priceList.find((cp) => cp.label === 'Install fee')!.value,

      priceList.find((cp) => cp.label === 'Mini Split 12k BTU (750 sqft)')!
        .value,
      priceList.find((cp) => cp.label === 'Mini Split 18k BTU (1000 sqft)')!
        .value,
      priceList.find((cp) => cp.label === 'Mini Split 24k BTU (1400 sqft)')!
        .value,

      priceList.find((cp) => cp.label === 'Dual head 24k BTU (2800 sqft)')!
        .value,
      priceList.find((cp) => cp.label === 'Install fee (dual head)')!.value,

      priceList.find((cp) => cp.label === 'Wiring (per ft)')!.value,
      priceList.find((cp) => cp.label === 'Conduit (per ft)')!.value,
    ]
  })()

  const miniSplits = JSON.parse(mini_split_tons || '[]') as schema.MiniSplit[]

  const filledOutRows = miniSplits.filter((ms) => !!ms.tons)

  if (filledOutRows.length === 0) {
    return [0, '']
  }

  for (const split of filledOutRows) {
    finalCost += miniSplitInstallFee

    const wiringCost =
      utils.parseInt(split.distanceToCondenser) *
      // 4 wires
      4 *
      // TODO: Ask Nirvana why this calc
      0.65 *
      wiringPrice
    finalCost += wiringCost

    const conduitCost = utils.parseInt(split.distanceToCondenser) * conduitPrice
    finalCost += conduitCost

    if (split.tons === 'mini_split_12kBTU') {
      finalCost += utils.parseInteger(split.qty) * mini_split_price_12kBTU
      finalCost += notesLines.push(
        `1 x MiniSplit 12k BTU${split.location ? ` - ${split.location}` : ''}${
          split.distanceToCondenser
            ? ` - ${split.distanceToCondenser}ft to condenser`
            : ''
        }`,
      )
    }
    if (split.tons === 'mini_split_18kBTU') {
      finalCost += utils.parseInteger(split.qty) * mini_split_price_18kBTU
      notesLines.push(
        `1 x MiniSplit 18k BTU - ${split.location} - ${split.distanceToCondenser}ft to condenser`,
      )
    }
    if (split.tons === 'mini_split_24kBTU') {
      finalCost += utils.parseInteger(split.qty) * mini_split_price_24kBTU
      notesLines.push(
        `1 x MiniSplit 24k BTU - ${split.location} - ${split.distanceToCondenser}ft to condenser`,
      )
    }
    if (split.tons === 'mini_split_dualHead_24kBTU') {
      finalCost +=
        utils.parseInteger(split.qty) * mini_split_price_dualHead_24kBTU

      //  Dual head = double wiring
      finalCost += wiringCost
      finalCost += conduitCost

      // Different install fee
      finalCost -= miniSplitInstallFee
      finalCost += miniSplitInstallFeeDualHead

      notesLines.push(
        `1 x Dual Head MiniSplit 24k BTU - ${split.location} - ${split.distanceToCondenser}ft to condenser`,
      )
    }
  }

  // const conduitLength = filledOutRows.reduce(
  //   (acc, nxt) => acc + utils.parseInt(nxt.distanceToCondenser),
  //   0,
  // )
  // notesLines.push(`${conduitLength} ft of conduit in total`)
  // notesLines.push(`${conduitLength * 4} ft of wiring in total`)

  if (roof_shingles_or_tiles === 'Tiles') {
    const tilesRoofFlatFee = priceList.find(
      (cp) => cp.label === 'Flat fee for tile roofs',
    )!.value

    finalCost += tilesRoofFlatFee

    notesLines.push('')
    notesLines.push(
      `A $${tilesRoofFlatFee} tiles roof flat fee is to be charged`,
    )
  }

  return [finalCost, notesLines.join('\n')]
}

const defaultMPUCalculator: Calculator = (
  {
    main_panel_upgrade_installation_company,
    main_panel_upgrade_needed_or_requested,
  },
  prices,
  state,
) => {
  let finalCost = 0
  const notesLines: string[] = []

  const priceList = (() => {
    if (state === 'california') {
      return prices.main_panel_upgrade.california.pricesByCity[0]!.list
    }
    return prices.main_panel_upgrade[state].list
  })()

  const mpuKey = `Main Panel Upgrade-${main_panel_upgrade_installation_company}`

  const price = priceList.find((x) => x.label === mpuKey)!.value

  if (main_panel_upgrade_installation_company) {
    if (main_panel_upgrade_needed_or_requested === 'needed') {
      notesLines.push('An upgrade is needed')
      finalCost += price
    }
    if (main_panel_upgrade_needed_or_requested === 'requested') {
      notesLines.push('An upgrade was requested by the customer')
      finalCost += price
    }
    if (main_panel_upgrade_needed_or_requested === 'relocation') {
      notesLines.push(
        "Relocation requested by customer, a site survey is needed before it's performed",
      )
    }
    notesLines.push(`Installer: ${main_panel_upgrade_installation_company}`)
  }

  return [finalCost, notesLines.join('\n')]
}

const nirvanaMPUCalculator: Calculator = (
  { main_panel_upgrade_rating },
  prices,
  state,
) => {
  if (!main_panel_upgrade_rating) {
    return [0, '']
  }

  const notesLines: string[] = [main_panel_upgrade_rating]

  if (main_panel_upgrade_rating.startsWith('600')) {
    return [0, notesLines.join('\n')]
  }

  const priceList =
    state === 'california'
      ? prices.main_panel_upgrade.california.pricesByCity[0]!.list
      : prices.main_panel_upgrade[state].list

  const price = priceList.find(
    (p) => p.label === main_panel_upgrade_rating,
  )!.value

  return [price, notesLines.join('\n')]
}

/**
 * @deprecated Nirvana requested to disable all promo pricing, leaving here for
 * reference
 */
const PROMO_PRICING_STR = 'Promo pricing has been applied'
type GlobalCalcRes = FieldToTrait<[newPrice: number, notes: string]>
/**
 * Handles global pricing schemes, such as combo deals, applicable to Nirvana
 * only right now. Returns a map of efficiency to price/notes tuple. Any pricing
 * / notes calculated by this should not be overwritten by individual
 * calculators, this global calculator will use the individual ones as needed.
 */
export const globalCalculator = (
  customer: utils.DeepReadonly<schema.Customer>,
  prices: utils.DeepReadonly<schema.SaleTag>,
  state: 'arizona' | 'california' | 'nevada',
  efficienciesChanged: schema.CustomerFields,
): GlobalCalcRes => {
  const res: Writable<GlobalCalcRes> = {}

  const inverterChanged = efficienciesChanged.includes('inverter_swap')
  const batteryChanged = efficienciesChanged.includes('battery_multiple')
  const inverterOrBatteryChanged = inverterChanged || batteryChanged

  const [inverterCost, inverterNotes] = efficiencyToCalculator.inverter_swap?.(
    customer,
    prices,
    state,
  )!
  const [batteryCost, batteryNotes] = efficiencyToCalculator.battery_multiple?.(
    customer,
    prices,
    state,
  )!
  const inverterAndBatteryBothEnabled =
    customer.inverter_swap === 'yes' && customer.battery_multiple === 'yes'
  /**
   * If cost is zero it's because something hasn't been filled in yet.
   */
  const inverterAndBatteryFilled =
    utils.parseFloating(inverterCost) > 0 &&
    utils.parseFloating(batteryCost) > 0

  if (
    // Nirvana requested to disable all promo pricing, leaving here for
    // reference
    Math.random() > 1 &&
    inverterOrBatteryChanged &&
    inverterAndBatteryBothEnabled &&
    inverterAndBatteryFilled
  ) {
    // Some necessary data hasn't been input yet
    if (
      batteryCost === 0 ||
      batteryNotes === '' ||
      inverterCost === 0 ||
      inverterNotes === ''
    ) {
      return res
    }

    let newInverterCost = inverterCost
    let newBatteryCost = batteryCost

    const inverterPriceList =
      state === 'california'
        ? prices.inverter_swap.california.pricesByCity[0]!.list
        : prices.inverter_swap[state].list
    const inverterPriceInstallFeeRegular = inverterPriceList.find(
      (p) => p.label === 'Install fee (per inverter)',
    )!.value
    const inverterPriceInstallFeePromo = inverterPriceList.find(
      (p) => p.label === 'Install fee (per inverter) (promo)',
    )!.value

    const batteryPriceList =
      state === 'california'
        ? prices.battery_multiple.california.pricesByCity[0]!.list
        : prices.battery_multiple[state].list
    const batteryPriceInstallFeeRegular = batteryPriceList.find(
      (p) => p.label === 'Install fee (per battery)',
    )!.value
    const batteryPriceInstallFeePromo = batteryPriceList.find(
      (p) => p.label === 'Install fee (per battery) (promo)',
    )!.value

    const inverterQty = utils.parseInt(customer.inverter_swap_qty)
    const batteryQty = utils.parseInt(customer.battery_multiple_how_many)
    // Deduct all regular install prices
    newInverterCost -= inverterQty * inverterPriceInstallFeeRegular
    newBatteryCost -= batteryQty * batteryPriceInstallFeeRegular
    // Add up install promo prices
    newInverterCost += inverterQty * inverterPriceInstallFeePromo
    newBatteryCost += batteryQty * batteryPriceInstallFeePromo

    res.inverter_swap = [
      newInverterCost,
      inverterNotes + '\n' + PROMO_PRICING_STR,
    ]
    res.battery_multiple = [
      newBatteryCost,
      batteryNotes + '\n' + PROMO_PRICING_STR,
    ]
  }
  // Go back to default cost/notes
  else if (inverterChanged || batteryChanged) {
    if (customer.inverter_swap === 'yes') {
      res.inverter_swap = [inverterCost, inverterNotes]
    }
    if (customer.battery_multiple === 'yes') {
      res.battery_multiple = [batteryCost, batteryNotes]
    }
  }

  return res
}

function extractPanelRange(
  str: string,
): [lowerBound: number, upperBound: number] {
  // Install for 0-10 panels (1-4Kw)
  const latterHalf = str.slice('Price for '.length)
  const digits = latterHalf.slice(0, latterHalf.indexOf('panels') - 1)

  const [lowerBoundStr, upperBoundStr] = digits.split('-')

  return [Number(lowerBoundStr), Number(upperBoundStr)]
}
export const efficiencyToCalculator: FieldToTrait<Calculator> = {
  air_conditioner(
    {
      air_conditioner_furnance,
      air_conditioner_new_tons,
      air_conditioner_replace_ducts,
      air_conditioner_swamp_cooler_use,
      air_conditioner_swamp_cooler_use_remove,
      air_conditioner_unit_type,
      air_conditioner_working,
    },
    prices,
    state,
  ) {
    let finalCost = 0
    const notesLines: string[] = []

    const priceList =
      state === 'california'
        ? prices.air_conditioner.california.pricesByCity[0]!.list
        : prices.air_conditioner[state].list

    // There's now 4 types of job:
    // 1. Full new installation
    // 2. Full replacement
    // 3. Replacement without ducts
    // 4. AC only replacement
    // We won't account for a AC-only + duct replacement as it will be rare
    const installationTypeNotes = (() => {
      if (air_conditioner_working === 'no') {
        return '(new installation)'
      }
      if (air_conditioner_unit_type.startsWith('roof')) {
        // Doesn't get offered the furnance question
        if (air_conditioner_replace_ducts === 'yes') {
          return '$$__FULL__REPLACEMENT'
        }
        return '(replacement)'
      }
      if (air_conditioner_unit_type.startsWith('split')) {
        if (
          air_conditioner_furnance === 'yes' &&
          air_conditioner_replace_ducts === 'yes'
        ) {
          return '$$__FULL__REPLACEMENT'
        }
        if (air_conditioner_furnance === 'yes') {
          return '(replacement)'
        }
        if (air_conditioner_furnance === 'no') {
          return '(ac only replacement)'
        }
        if (
          air_conditioner_replace_ducts === 'yes' &&
          air_conditioner_furnance === 'no'
        ) {
          // Unhandled scenario, fall back to ac only
          return '(ac only replacement)'
        }
      }

      throw new Error('Should be unreachable?')
    })()

    const [splitOrRoof, gasOrElectric] = air_conditioner_unit_type
      .toLowerCase()
      .split('_')

    if (installationTypeNotes === '(new installation)') {
      notesLines.push('Scope of Work: HVAC System Installation')
      notesLines.push('\n')
      notesLines.push('Project Overview')
      notesLines.push(
        `This project involves the installation of a new ${air_conditioner_new_tons}-ton ${splitOrRoof} ${
          splitOrRoof === 'roof' ? '' : gasOrElectric + ' '
        }HVAC unit, including a furnace and ductwork. The work will ensure the HVAC system operates efficiently and complies with local building codes.`,
      )
      notesLines.push('\n')
      notesLines.push('1. HVAC Unit Installation')
      notesLines.push('- Install a new HVAC unit.')
      notesLines.push('- Connect and integrate the furnace with the HVAC unit.')
      notesLines.push(
        '- Ensure proper electrical connections, grounding, and circuit protection.',
      )
      notesLines.push(
        '- Test the unit for optimal functionality, including heating and cooling performance.',
      )
      notesLines.push('\n')
      notesLines.push('2. Ductwork Installation')
      notesLines.push(
        '- Design and install new duct systems based on load calculations to ensure proper airflow and energy efficiency.',
      )
      notesLines.push(
        '- Use insulated, code-compliant materials for all ducts to enhance thermal performance.',
      )
      notesLines.push('- Seal all connections to prevent air leaks.')
      notesLines.push(
        '- Install and position registers and grilles for even air distribution.',
      )
      notesLines.push('\n')
      notesLines.push('3. Accessories and Components')
      notesLines.push(
        '- Install a new thermostat and ensure proper functionality.',
      )
      notesLines.push(
        '- Integrate air filters and ensure compatibility with the HVAC system.',
      )
      notesLines.push(
        '- Check and secure connections for return air and supply air systems.',
      )
      notesLines.push('\n')
      notesLines.push('4. Testing and Balancing')
      notesLines.push(
        '- Perform system testing and balancing to ensure proper airflow and temperature distribution.',
      )
      notesLines.push(
        '- Verify energy efficiency and compliance with HVAC standards.',
      )
      notesLines.push('\n')
      notesLines.push('5. Cleanup and Final Inspection')
      notesLines.push('- Clean the work area after installation.')
    }
    if (installationTypeNotes === '$$__FULL__REPLACEMENT') {
      notesLines.push('Scope of Work: HVAC System Replacement')
      notesLines.push('\n')
      notesLines.push('Project Overview')
      notesLines.push(
        `This project involves the replacement of a ${air_conditioner_new_tons}-ton ${splitOrRoof} ${
          splitOrRoof === 'roof' ? '' : gasOrElectric + ' '
        }HVAC unit, including a furnace and all existing ductwork. The work will ensure the HVAC system operates efficiently and complies with local building codes.`,
      )
      notesLines.push('\n')
      notesLines.push('1. HVAC Unit Replacement')
      notesLines.push('- Uninstall the existing HVAC unit and furnace.')
      notesLines.push('- Install the new HVAC unit and furnace.')
      notesLines.push('- Connect and integrate the furnace with the HVAC unit.')
      notesLines.push(
        '- Ensure proper electrical connections, grounding, and circuit protection.',
      )
      notesLines.push(
        '- Test the unit for optimal functionality, including heating and cooling performance.',
      )
      notesLines.push('\n')
      notesLines.push('2. Ductwork Replacement')
      notesLines.push('- Remove all existing ductwork.')
      notesLines.push(
        '- Design and install new duct systems based on load calculations to ensure proper airflow and energy efficiency.',
      )
      notesLines.push(
        '- Use insulated, code-compliant materials for all ducts to enhance thermal performance.',
      )
      notesLines.push('Seal all connections to prevent air leaks.')
      notesLines.push(
        '- Install and position registers and grilles for even air distribution.',
      )
      notesLines.push('\n')
      notesLines.push('3. Accessories and Components')
      notesLines.push(
        '- Install a new thermostat and ensure proper functionality.',
      )
      notesLines.push(
        '- Integrate air filters and ensure compatibility with the HVAC system.',
      )
      notesLines.push(
        '- Check and secure connections for return air and supply air systems.',
      )
      notesLines.push('\n')
      notesLines.push('4. Testing and Balancing')
      notesLines.push(
        '- Perform system testing and balancing to ensure proper airflow and temperature distribution.',
      )
      notesLines.push(
        '- Verify energy efficiency and compliance with HVAC standards.',
      )
      notesLines.push('\n')
      notesLines.push('5. Cleanup and Final Inspection')
      notesLines.push(
        '- Remove and dispose of old equipment and ductwork in compliance with environmental regulations.',
      )
      notesLines.push('- Clean the work area after installation.')
    }
    if (installationTypeNotes === '(replacement)') {
      notesLines.push('Scope of Work: HVAC Replacement')
      notesLines.push('\n')
      notesLines.push('Project Overview')
      notesLines.push(
        `This project involves the replacement of a ${air_conditioner_new_tons}-ton ${splitOrRoof} ${
          splitOrRoof === 'roof' ? '' : gasOrElectric + ' '
        }HVAC unit. The work will ensure the HVAC system operates efficiently and complies with local building codes.`,
      )
      notesLines.push('\n')
      notesLines.push('1. HVAC Unit Replacement')
      notesLines.push('- Uninstall the existing HVAC unit')
      notesLines.push('- Install a new HVAC unit.')
      notesLines.push('- Connect and integrate the furnace with the HVAC unit.')
      notesLines.push(
        '- Ensure proper electrical connections, grounding, and circuit protection.',
      )
      notesLines.push(
        '- Test the unit for optimal functionality, including heating and cooling performance.',
      )
      notesLines.push('\n')
      notesLines.push('2. Accessories and Components')
      notesLines.push(
        '- Install a new thermostat and ensure proper functionality.',
      )
      notesLines.push(
        '- Integrate air filters and ensure compatibility with the HVAC system.',
      )
      notesLines.push(
        '- Check and secure connections for return air and supply air systems.',
      )
      notesLines.push('\n')
      notesLines.push('3. Testing and Balancing')
      notesLines.push(
        '- Perform system testing and balancing to ensure proper airflow and temperature distribution.',
      )
      notesLines.push(
        '- Verify energy efficiency and compliance with HVAC standards.',
      )
      notesLines.push('\n')
      notesLines.push('4. Cleanup and Final Inspection')
      notesLines.push(
        '- Remove and dispose of old equipment in compliance with environmental regulations.',
      )
      notesLines.push('- Clean the work area after installation.')
    }
    if (installationTypeNotes === '(ac only replacement)') {
      notesLines.push('Scope of Work: AC Replacement')
      notesLines.push('\n')
      notesLines.push('Project Overview')
      notesLines.push(
        `This project involves the replacement of a ${air_conditioner_new_tons}-ton split ${gasOrElectric} AC unit. The work will ensure the HVAC system operates efficiently and complies with local building codes.`,
      )
      notesLines.push('\n')
      notesLines.push('1. AC Unit Installation')
      notesLines.push('- Uninstall the existing AC unit')
      notesLines.push('- Install a new AC unit.')
      notesLines.push('- Connect and integrate the furnace with the AC unit.')
      notesLines.push(
        '- Ensure proper electrical connections, grounding, and circuit protection.',
      )
      notesLines.push(
        '- Test the unit for optimal functionality, including heating and cooling performance.',
      )
      notesLines.push('\n')
      notesLines.push('2. Accessories and Components')
      notesLines.push(
        '- Install a new thermostat and ensure proper functionality.',
      )
      notesLines.push(
        '- Integrate air filters and ensure compatibility with the AC system.',
      )
      notesLines.push(
        '- Check and secure connections for return air and supply air systems.',
      )
      notesLines.push('\n')
      notesLines.push('3. Testing and Balancing')
      notesLines.push(
        '- Perform system testing and balancing to ensure proper airflow and temperature distribution.',
      )
      notesLines.push(
        '- Verify energy efficiency and compliance with AC standards.',
      )
      notesLines.push('\n')
      notesLines.push('4. Cleanup and Final Inspection')
      notesLines.push(
        '- Remove and dispose of old equipment in compliance with environmental regulations.',
      )
      notesLines.push('- Clean the work area after installation.')
    }

    if (air_conditioner_swamp_cooler_use === 'yes') {
      notesLines.push('\n')

      if (air_conditioner_swamp_cooler_use_remove === 'yes') {
        notesLines.push('Swamp cooler will be removed')

        finalCost += priceList.find(
          (p) => p.label === 'Swamp Cooler Removal',
        )!.value
      } else {
        notesLines.push('Swamp cooler is present')
      }
    }

    const installationTypePrice = (() => {
      // Replacing all AC furnance and ducts is the same as new install
      if (installationTypeNotes === '$$__FULL__REPLACEMENT') {
        return '(new installation)'
      }
      return installationTypeNotes
    })()

    const price: number = priceList.find(({ label: _label }) => {
      const label = _label.toLowerCase()

      return (
        label.includes(air_conditioner_new_tons + 't') &&
        label.includes(splitOrRoof!) &&
        // Roof has no gas or electric
        label.includes(splitOrRoof === 'roof' ? '' : gasOrElectric!) &&
        label.includes(installationTypePrice)
      )
    })!.value

    finalCost += price

    if (
      installationTypePrice === '(ac only replacement)' &&
      air_conditioner_replace_ducts === 'yes'
    ) {
      const ductReplPrice: number = priceList.find(
        ({ label }) => label === 'Duct Replacement (AC only)',
      )!.value

      finalCost += ductReplPrice
    }

    return [finalCost, notesLines.join('\n')]
  },
  attic_fan({ attic_fan_quantity }, prices, state) {
    let finalCost = 0
    const notesLines: string[] = []

    const price = (() => {
      if (state === 'california') {
        return prices.attic_fan.california.pricesByCity[0]!.list[0]!.value
      }
      return prices.attic_fan[state].list[0]!.value
    })()

    if (attic_fan_quantity) {
      finalCost += price * utils.parseInteger(attic_fan_quantity)
      notesLines.push(`${attic_fan_quantity} attic fans will be installed`)
    }

    return [finalCost, notesLines.join('\n')]
  },
  attic_insulation(
    { attic_insulation_how_much, attic_insulation_type },
    prices,
    state,
  ) {
    if (!attic_insulation_how_much || !attic_insulation_type) {
      return [0, '']
    }
    let finalCost = 0
    const notesLines: string[] = []
    const priceList =
      (state === 'california'
        ? prices.attic_insulation.california.pricesByCity[0]!.list
        : prices.attic_insulation[state]?.list) || []
    const price = priceList[0]?.value || 0
    finalCost = price * utils.parseFloating(attic_insulation_how_much)
    //#region notes
    if (attic_insulation_how_much) {
      notesLines.push(`Total sq of insulation: ${attic_insulation_how_much}`)
    }
    if (attic_insulation_type) {
      notesLines.push(`Type of insulation: ${attic_insulation_type}`)
    }
    //#endregion notes
    return [finalCost, notesLines.join('\n')]
  },
  battery(
    { main_panel_upgrade_installation_company, battery_size, battery_type },
    prices,
    state,
  ) {
    let finalCost = 0
    const notesLines: string[] = []

    if (
      main_panel_upgrade_installation_company &&
      battery_size &&
      battery_type
    ) {
      const priceList = (() => {
        if (state === 'california') {
          return prices.battery.california.pricesByCity[0]!.list
        }
        return prices.battery[state].list
      })()

      const batteryKey = `Battery ${battery_type}-${main_panel_upgrade_installation_company}-${battery_size}`

      const price = priceList.find((x) => x.label === batteryKey)!.value || 0

      finalCost += price

      notesLines.push(`Installer: ${main_panel_upgrade_installation_company}`)
      notesLines.push(`Battery type: ${battery_type}`)
      notesLines.push(`Battery spec: ${battery_size}`)
    }

    return [finalCost, notesLines.join('\n')]
  },
  battery_multiple(
    {
      battery_multiple_bank_location,
      battery_multiple_customer_material,
      battery_multiple_distance_to_main_panel,
      battery_multiple_how_many,
    },
    prices,
    state,
  ) {
    const qty = utils.parseInt(battery_multiple_how_many)
    const distance = utils.parseFloating(
      battery_multiple_distance_to_main_panel,
    )

    if (!battery_multiple_bank_location || !qty) {
      return [0, '']
    }

    let finalCost = 0
    const notesLines: string[] = []

    const priceList =
      state === 'california'
        ? prices.battery_multiple.california.pricesByCity[0]!.list
        : prices.battery_multiple[state].list
    const priceInstallFee =
      priceList.find(
        (p) =>
          p.label ===
          (battery_multiple_customer_material === 'yes'
            ? 'Install fee (per battery) (materials provided by customer)'
            : 'Install fee (per battery)'),
      )?.value || 0
    const priceEachBattery =
      priceList.find((p) => p.label === battery_multiple_bank_location)
        ?.value || 0
    const priceWiringOutdoor =
      priceList.find((p) => p.label === 'Outdoor wiring (per ft)')?.value || 0
    const priceWiringIndoor =
      priceList.find((p) => p.label === 'Indoor wiring (per ft)')?.value || 0
    const systemToWiring: Record<string, number> = {
      'EG4 14.3 Outdoor': priceWiringOutdoor,
      'EG4 16 Kw Indoor': priceWiringIndoor,
      'Fortress Power 12k Envy': priceWiringOutdoor,
    }
    const priceWiring = systemToWiring[battery_multiple_bank_location] || 0
    const priceConduit =
      priceList.find((p) => p.label === '¾" Conduit (per ft)')?.value || 0

    finalCost += qty * priceEachBattery
    finalCost += qty * priceInstallFee
    finalCost += distance * priceConduit
    finalCost +=
      distance * // 4 wires?
      4 *
      // TODO: Ask Nirvana why this calc
      0.65 *
      priceWiring

    if (qty > 1) {
      notesLines.push(`${qty} x batteries`)
    } else {
      notesLines.push('One battery will be installed')
    }
    notesLines.push(
      `${distance} ft of ${battery_multiple_bank_location} wiring total`,
    )
    notesLines.push(`Bank location: ${battery_multiple_bank_location}s`)
    // notesLines.push(`${distance * qty} ft of ¾" conduit in total`)

    return [finalCost, notesLines.join('\n')]
  },
  can_light_new(
    {
      can_light_new_how_many,
      can_light_new_will_remove,
      can_light_new_will_remove_how_many,
      can_light_new_high_ceiling,
    },
    prices,
    state,
  ) {
    let finalCost = 0
    const notesLines: string[] = []

    const priceList =
      state === 'california'
        ? prices.can_light_new.california.pricesByCity[0]!.list
        : prices.can_light_new[state].list

    const qty = utils.parseInt(can_light_new_how_many)
    const perLightPrice = priceList.find((p) => p.label === 'Per light')!.value
    finalCost += qty * perLightPrice
    notesLines.push(`${qty} x can light`)

    if (can_light_new_will_remove === 'yes') {
      const removalPrice = priceList.find(
        (p) => p.label === 'Removal (per light)',
      )!.value
      const removeQty = utils.parseInt(can_light_new_will_remove_how_many)
      finalCost += removeQty * removalPrice
      notesLines.push(`${removeQty} x can light removal`)
    }

    if (can_light_new_high_ceiling === 'yes') {
      const scaffoldingPrice = priceList.find(
        (p) => p.label === 'Scaffolding (ceilings above 12ft)',
      )!.value
      finalCost += scaffoldingPrice
      notesLines.push('Ceiling height above 12ft, scaffolding will be used')
    }

    const minimumCharge = priceList.find(
      (p) => p.label === 'Minimum charge',
    )!.value
    return [Math.max(minimumCharge, finalCost), notesLines.join('\n')]
  },
  ceiling_fan({ ceiling_fan_detail }, prices, state) {
    const filledOutRows = (
      JSON.parse(ceiling_fan_detail) as schema.CeilingFan[]
    ).filter((cf) => !!cf.type)

    if (filledOutRows.length === 0) {
      return [0, '']
    }

    const priceList =
      state === 'california'
        ? prices.ceiling_fan.california.pricesByCity[0]!.list
        : prices.ceiling_fan[state].list

    let finalCost = 0
    const notesLines: string[] = []

    for (const ceilingFan of filledOutRows) {
      const price = priceList.find((p) => p.label === ceilingFan.type)!.value
      finalCost += price
      notesLines.push(
        `1 x ${ceilingFan.type}${
          ceilingFan.notes ? ' -- ' + ceilingFan.notes : ''
        }`,
      )
    }

    return [finalCost, notesLines.join('\n')]
  },
  derate({ main_panel_upgrade_installation_company }, prices, state) {
    if (!main_panel_upgrade_installation_company) {
      return [0, '']
    }

    const price = (() => {
      if (state === 'california') {
        return prices.derate.california.pricesByCity[0]!.list.find(
          (p) =>
            p.label === `Derate (${main_panel_upgrade_installation_company})`,
        )!.value
      }
      return prices.derate[state].list.find(
        (p) =>
          p.label === `Derate (${main_panel_upgrade_installation_company})`,
      )!.value
    })()

    return [
      price,
      `A derate will be performed\nInstaller: ${main_panel_upgrade_installation_company}`,
    ]
  },
  duct_seal(_, prices, state) {
    const price = (() => {
      if (state === 'california') {
        return prices.duct_seal.california.pricesByCity[0]!.list[0]!.value
      }
      return prices.duct_seal[state].list[0]!.value
    })()

    return [price, 'Duct seal will be applied.']
  },
  flat_roof_panels({ flat_roof_panels_how_many }, prices, state) {
    let finalCost = 0
    const notesLines: string[] = []
    const price = (() => {
      if (state === 'california') {
        return prices.flat_roof_panels.california.pricesByCity[0]!.list[0]!
          .value
      }
      return prices.flat_roof_panels[state].list[0]!.value
    })()

    if (flat_roof_panels_how_many) {
      finalCost += price * utils.parseInteger(flat_roof_panels_how_many)
    }

    return [finalCost, notesLines.join('\n')]
  },
  home_run({ home_run_ft }, prices, state) {
    if (!home_run_ft) {
      return [0, '']
    }

    const priceList =
      state === 'california'
        ? prices.home_run.california.pricesByCity[0]!.list
        : prices.home_run[state].list

    const basePrice = priceList.find(
      (p) => p.label === 'New home runs (up to 20ft)',
    )!.value

    let finalCost = 0

    finalCost += basePrice

    const ft = utils.parseFloating(home_run_ft)

    if (ft > 20) {
      const additionalFt = ft - 20
      const pricePerFt = priceList.find(
        (p) => p.label === 'Per feet after 21ft',
      )!.value
      finalCost += pricePerFt * additionalFt
    }

    return [finalCost, `${ft.toFixed(2)} feet of new home runs`]
  },
  inverter_swap(
    {
      inverter_swap_customer_material,
      inverter_swap_distance_to_mpu,
      inverter_swap_qty,
      inverter_swap_size,
      main_panel_location,
    },
    prices,
    state,
  ) {
    let finalCost = 0
    const notesLines: string[] = []

    if (!inverter_swap_size || !inverter_swap_qty) {
      return [finalCost, '']
    }

    const inverterSwapDistanceToMpu = utils.parseFloating(
      inverter_swap_distance_to_mpu,
    )

    const priceList =
      state === 'california'
        ? prices.inverter_swap.california.pricesByCity[0]!.list
        : prices.inverter_swap[state].list

    const systemPrices = {
      'EG4 6000 XP': priceList.find((cp) => cp.label === 'EG4 6000 XP')?.value,
      'EG4 12000 XP': priceList.find((cp) => cp.label === 'EG4 12000 XP')
        ?.value,
      'EG4 12KPV': priceList.find((cp) => cp.label === 'EG4 12KPV')?.value,
      'EG4 18KPV': priceList.find((cp) => cp.label === 'EG4 18KPV')?.value,
      'EG4 flex boss 18': priceList.find(
        (cp) => cp.label === 'EG4 flex boss 18',
      )?.value,
      'EG4 flex boss 21': priceList.find(
        (cp) => cp.label === 'EG4 flex boss 21',
      )?.value,
      'Fortress Power 12k': priceList.find(
        (cp) => cp.label === 'Fortress Power 12k',
      )?.value,
      'Envy Duo 21': priceList.find((cp) => cp.label === 'Envy Duo 21')?.value,
    } as utils.DictB<number>

    const wiring_price_3_fourths_price = priceList.find(
      (cp) => cp.label === '¾" Wiring (per ft)',
    )
    const wiring_price_1_inch_price = priceList.find(
      (cp) => cp.label === '1" Wiring (per ft)',
    )
    const wiring_price_1_1_fourth_price = priceList.find(
      (cp) => cp.label === '1-¼" Wiring (per ft)',
    )
    const systemToWiring = {
      'EG4 6000 XP': wiring_price_3_fourths_price,
      'EG4 12000 XP': wiring_price_1_inch_price,
      'EG4 12KPV': wiring_price_1_inch_price,
      'EG4 18KPV': wiring_price_1_1_fourth_price,
      'EG4 flex boss 18': wiring_price_1_1_fourth_price,
      'EG4 flex boss 21': wiring_price_1_1_fourth_price,
      'Fortress Power 12k': wiring_price_1_1_fourth_price,
    } as utils.DictB<schema.Price>
    const wiringPrice = systemToWiring[inverter_swap_size]

    const conduit_price_3_fourths_price = priceList.find(
      (cp) => cp.label === '¾" Conduit (per ft)',
    )
    const conduit_price_1_inch_price = priceList.find(
      (cp) => cp.label === '1" Conduit (per ft)',
    )
    const conduit_price_1_1_fourth_price = priceList.find(
      (cp) => cp.label === '1-¼" Conduit (per ft)',
    )
    // TODO: How to have this in the DB
    const systemToConduit = {
      'EG4 6000 XP': conduit_price_3_fourths_price,
      'EG4 12000 XP': conduit_price_1_inch_price,
      'EG4 12KPV': conduit_price_1_inch_price,
      'EG4 18KPV': conduit_price_1_1_fourth_price,
      'EG4 flex boss 18': conduit_price_1_1_fourth_price,
      'EG4 flex boss 21': conduit_price_1_1_fourth_price,
      'Fortress Power 12k': conduit_price_1_1_fourth_price,
      'Envy Duo 21': conduit_price_1_1_fourth_price,
    } as utils.DictB<schema.Price>

    const conduitPrice = systemToConduit[inverter_swap_size]

    finalCost += systemPrices[inverter_swap_size] || 0
    finalCost += inverterSwapDistanceToMpu * (conduitPrice?.value || 0)
    finalCost +=
      inverterSwapDistanceToMpu *
      // 4 wires
      4 *
      // TODO: Ask Nirvana why this calc
      0.65 *
      (wiringPrice?.value || 0)

    const installPriceRegular = priceList.find(
      (cp) => cp.label === 'Install fee (per inverter)',
    )?.value

    const installPriceMaterialsProvided = priceList.find(
      (cp) =>
        cp.label ===
        'Install fee (per inverter) (materials provided by customer)',
    )?.value

    finalCost +=
      (inverter_swap_customer_material === 'yes'
        ? installPriceMaterialsProvided
        : installPriceRegular) || 0

    notesLines.push(`System size: ${inverter_swap_size}`)
    main_panel_location &&
      notesLines.push(`Main panel location: ${main_panel_location}`)
    inverterSwapDistanceToMpu &&
      notesLines.push(
        `${inverterSwapDistanceToMpu.toFixed(
          2,
        )} ft of conduit (Distance to Main Panel)`,
      )
    inverterSwapDistanceToMpu &&
      notesLines.push(
        `${(inverterSwapDistanceToMpu * 4).toFixed(2)} ft of wiring`,
      )
    notesLines.push(
      `Conduit width: ${conduitPrice?.label.replace(' Conduit (per ft)', '')}`,
    )
    notesLines.push(
      inverter_swap_customer_material === 'yes'
        ? 'Customer will provide materials'
        : 'Nirvana energy will provide materials',
    )

    finalCost *= inverter_swap_qty

    return [finalCost, notesLines.join('\n')]
  },
  main_panel_upgrade:
    env.CODENAME === 'nirvana' ? nirvanaMPUCalculator : defaultMPUCalculator,
  mini_split:
    env.CODENAME === 'nirvana'
      ? nirvanaMiniSplitCalculator
      : defaultMiniSplitCalculator,
  new_windows(
    {
      createdAt,
      new_windows_color,
      new_windows_grid,
      new_windows_sliding_glass,
      new_windows_sliding_glass_sqft,
      new_windows_sqft_each_window,
    },
    prices,
    state,
  ) {
    let finalCost = 0
    const notesLines: string[] = []
    const pricePerSqft = (() => {
      if (state === 'california') {
        return prices.new_windows.california.pricesByCity[0]!.list.find(
          (cp) => cp.label === 'Per Sqft',
        )!.value
      }
      return (
        prices.new_windows[state]?.list?.find((cp) => cp.label === 'Per Sqft')
          ?.value || 0
      )
    })()
    // @ts-ignore Special Case
    const priceColors = prices.new_windows.priceColors

    const windowGroups: readonly schema.WindowGroup[] = JSON.parse(
      new_windows_sqft_each_window || '[]',
    )
    if (!utils.isArray(windowGroups)) {
      throw new TypeError('new_windows_sqft_each_window not an array')
    }
    for (const obj of windowGroups) {
      if (!schema.isWindowGroup(obj)) {
        throw new TypeError(`Object inside sqftWindow[] not a WindowGroup`)
      }
    }
    const filledWindowGroups = windowGroups.filter(
      (sw) => !!sw.size && !!sw.window,
    )
    let totalSqft = 0
    let totalWindows = 0
    let amtColor = 0
    for (const windowGroup of filledWindowGroups) {
      const qty = utils.parseInteger(windowGroup.window)
      const size = utils.parseFloating(windowGroup.size)

      totalSqft += qty * size
      totalWindows += qty

      if (createdAt > Jun4_2024) {
        // Newer customer, has a global color selector
        const colorPrice = priceColors[new_windows_color]
        if (colorPrice) amtColor += colorPrice * qty
      } else {
        // Older customer, has an individual color selector for each window
        // group
        const colorPrice = priceColors[windowGroup.color]
        if (colorPrice) amtColor += colorPrice * qty
      }
    }
    finalCost += utils.parseFloating(pricePerSqft) * totalSqft + amtColor
    notesLines.push('Scope of work:')
    notesLines.push('')
    notesLines.push(
      'Remove and replace existing windows with new energy-efficient models. The windows will be properly installed and sealed. Old materials will be disposed of, and the worksite will be cleaned post-installation.',
    )
    notesLines.push('')
    notesLines.push('Type of windows: Low E, doble panel windows')
    notesLines.push('Material: Vinyl')
    if (new_windows_color) {
      notesLines.push(`Color: ${new_windows_color}`)
    }
    if (totalWindows > 0) {
      notesLines.push(`Total number of windows: ${totalWindows}`)
    }
    if (totalSqft > 0) {
      notesLines.push(`Total measure of windows in sqft: ${totalSqft}`)
    }

    const slidingNotes: string[] = []
    if (new_windows_sliding_glass === 'yes') {
      const slidingDoorPrices = (() => {
        if (state === 'california') {
          return {
            'Sliding Doors (5 ft)':
              prices.new_windows.california.pricesByCity[0]!.list.find(
                (cp) => cp.label === 'Sliding Doors (5 ft)',
              )!.value,
            'Sliding Doors (6 ft)':
              prices.new_windows.california.pricesByCity[0]!.list.find(
                (cp) => cp.label === 'Sliding Doors (6 ft)',
              )!.value,
            'Sliding Doors (8 ft)':
              prices.new_windows.california.pricesByCity[0]!.list.find(
                (cp) => cp.label === 'Sliding Doors (8 ft)',
              )!.value,
          }
        }
        return {
          'Sliding Doors (5 ft)': prices.new_windows[state].list.find(
            (cp) => cp.label === 'Sliding Doors (5 ft)',
          )!.value,
          'Sliding Doors (6 ft)': prices.new_windows[state].list.find(
            (cp) => cp.label === 'Sliding Doors (6 ft)',
          )!.value,
          'Sliding Doors (8 ft)': prices.new_windows[state].list.find(
            (cp) => cp.label === 'Sliding Doors (8 ft)',
          )!.value,
        }
      })()
      const slidingDoors = JSON.parse(
        new_windows_sliding_glass_sqft || '[]',
      ) as schema.SlidingGlassDoorGroup[]
      const filledSlidingDoors = slidingDoors.filter(
        (sd) => !!sd.size && !!sd.total,
      )
      for (const slidingDoor of filledSlidingDoors) {
        const price =
          slidingDoorPrices[slidingDoor.size as keyof typeof slidingDoorPrices]
        finalCost += price * utils.parseInteger(slidingDoor.total)
      }

      const totalSliding = filledSlidingDoors.reduce(
        (count, g) => count + utils.parseInt(g.total),
        0,
      )
      if (totalSliding) {
        notesLines.push(`Total number of sliding glass doors: ${totalSliding}`)
      }

      slidingNotes.push(
        ...filledSlidingDoors.map(
          (g) =>
            `${g.total} Sliding glass ${
              g.total > 1 ? 'doors' : 'door'
            } - Size of the sliding ${g.total > 1 ? 'doors' : 'door'} ${
              schema.slidingToSize[g.size as keyof typeof schema.slidingToSize]
            } ft`,
        ),
      )
    }

    notesLines.push(`Grids included: ${new_windows_grid}`)

    notesLines.push('Windows Details')

    notesLines.push(
      ...filledWindowGroups.map(
        (g) =>
          `${g.window} ${g.window > 1 ? 'windows' : 'window'} - Size ${
            g.size
          } sqft${
            createdAt < Jun4_2024 && g.color
              ? ` - Color ${g.color.toLowerCase()}`
              : ''
          }`,
      ),
    )

    notesLines.push(...slidingNotes)

    return [finalCost, notesLines.join('\n')]
  },
  nirvana_panels(
    {
      nirvana_panels_distance_to_main_panel,
      nirvana_panels_how_many,
      nirvana_panels_panel_scenario,
    },
    prices,
    state,
  ) {
    if (!nirvana_panels_how_many || !nirvana_panels_panel_scenario) {
      return [0, '']
    }

    const qty = utils.parseInt(nirvana_panels_how_many)

    const priceList =
      state === 'california'
        ? prices.nirvana_panels.california.pricesByCity[0]!.list
        : prices.nirvana_panels[state].list

    let finalCost = 0
    const notesLines: string[] = []

    const panelsCostForQty = priceList.find((p) => {
      const [lowerBound, upperBound] = extractPanelRange(p.label)

      console.debug([lowerBound, upperBound])

      return qty >= lowerBound && qty <= upperBound
    })!.value
    finalCost += panelsCostForQty

    const priceConduit = priceList.find(
      (p) => p.label === '1-¼" Conduit (per ft)',
    )!.value
    /**
     * First 40 ft included
     */
    const distance =
      utils.parseFloating(nirvana_panels_distance_to_main_panel) - 40
    if (distance > 0) {
      finalCost += distance * priceConduit
    }

    const subpanelInstallPrice = priceList.find(
      (p) => p.label === 'Subpanel install',
    )!.value
    const gridTiedPermits = priceList.find(
      (p) => p.label === 'Grid-tied permits',
    )!.value

    notesLines.push(`${qty} panels will be installed`)

    if (nirvana_panels_panel_scenario === 'Grid-tied') {
      finalCost += gridTiedPermits
      notesLines.push('Grid permits will be pulled')
      finalCost += subpanelInstallPrice
      notesLines.push('Sub panel will be installed')
    }
    if (nirvana_panels_panel_scenario === 'Off-grid') {
      finalCost += subpanelInstallPrice
      notesLines.push('Sub panel will be installed')
    }

    return [finalCost, notesLines.join('\n')]
  },
  outlet({ outlet_detail }, prices, state) {
    const filledOutRows = (
      JSON.parse(outlet_detail || '[]') as schema.OutletGroup[]
    ).filter((og) => utils.parseInt(og.qty) > 0)

    if (filledOutRows.length === 0) {
      return [0, '']
    }

    const priceList =
      state === 'california'
        ? prices.outlet.california.pricesByCity[0]!.list
        : prices.outlet[state].list
    const priceMinimumCharge = priceList.find(
      (p) => p.label === 'Minimum charge',
    )!.value
    const priceFirstOutlet = priceList.find(
      (p) => p.label === 'First outlet (up to 10ft relocation)',
    )!.value
    const priceAdditionalOutlet = priceList.find(
      (p) => p.label === 'Additional outlet (up to 10ft relocation)',
    )!.value
    const priceAdditionalRelFt = priceList.find(
      (p) => p.label === 'Additional relocation ft (after 10 feet)',
    )!.value
    const priceMaxChargeOneOutlet = priceList.find(
      (p) => p.label === 'Max charge for 1 outlet',
    )!.value

    let finalCost = 0
    const notesLines: string[] = []

    for (const {
      qty: _qty,
      relocationFeet: _relocationFeet,
      room,
    } of filledOutRows) {
      const qty = utils.parseInt(_qty)
      const relocationFeet = JSON.parse(_relocationFeet) as utils.strings

      // eslint-disable-next-line no-useless-concat
      notesLines.push(room ? `(${room})` : '' + ` ${qty} x outlets`)
      notesLines.push(`Relocation feet each:`)

      for (const i of utils.range(qty)) {
        const feet = utils.parseFloating(relocationFeet[i])
        notesLines.push(`  (${String.fromCharCode(65 + i)}): ${feet}ft`)
      }

      let thisRoomCost = 0

      // Already filtered above to have qty >= 1
      thisRoomCost += priceFirstOutlet

      thisRoomCost +=
        priceAdditionalRelFt *
        Math.max(0, utils.parseFloating(relocationFeet[0]) - 10)

      for (const i of utils.range(qty - 1, 1)) {
        const ft = utils.parseFloating(relocationFeet[i])
        thisRoomCost += priceAdditionalOutlet
        thisRoomCost += Math.max(0, ft - 10) * priceAdditionalRelFt
      }

      if (qty === 1) {
        thisRoomCost = Math.min(thisRoomCost, priceMaxChargeOneOutlet)
      }
      finalCost += thisRoomCost
    }

    return [Math.max(finalCost, priceMinimumCharge), notesLines.join('\n')]
  },
  panel_removal({ panel_removal_how_many }, prices, state) {
    let finalCost = 0
    const notesLines: string[] = []

    const price = (() => {
      if (state === 'california') {
        return prices.panel_removal.california.pricesByCity[0]!.list[0]!.value
      }
      return prices.panel_removal[state].list[0]!.value
    })()

    if (panel_removal_how_many) {
      finalCost += price * utils.parseInteger(panel_removal_how_many)
      notesLines.push(`${panel_removal_how_many} panels will be removed`)
    }

    return [finalCost, notesLines.join('\n')]
  },
  protection({ protection_which }, prices, state) {
    if (!protection_which) {
      return [0, '']
    }

    const notesLines: string[] = []
    notesLines.push(
      `Type of surge protection: ${
        protection_which.toLowerCase().includes('soft')
          ? 'Soft start'
          : 'Regular'
      }`,
    )

    const priceList =
      state === 'california'
        ? prices.protection.california.pricesByCity[0]!.list
        : prices.protection[state].list

    const price = priceList.find((p) => p.label === protection_which)!.value

    return [price, notesLines.join('\n')]
  },
  roof(customer, prices, state) {
    if (!checkAllRoofFilled(customer)) {
      return [0, '']
    }
    const {
      roof_fascia_included_square_footage,
      roof_fascia_included,
      roof_layers_how_many,
      roof_layover_or_tear,
      roof_tear_material,
      roof_patio_how_many,
      roof_patio_included,
      roof_pitch,
      roof_plywood_replaced_square,
      roof_plywood_replaced,
      roof_plywood_under_tile,
      roof_square_footage,
      roof_will_add_license,
      roof_commission_add_up,
    } = customer

    const priceList = (() => {
      if (state === 'california') {
        return prices.roof.california.pricesByCity[0]!.list
      }
      return prices.roof[state].list
    })()
    let finalCost = 0
    const notesLines: string[] = []

    if (roof_square_footage) {
      notesLines.push(`Roof measurement: ${roof_square_footage}`)
    }
    if (roof_layover_or_tear) {
      notesLines.push(
        `Type of work: ${
          roof_layover_or_tear === schema.RoofWorkType.ReRoofShingles
            ? 'Re Roof (Shingles)'
            : roof_layover_or_tear
        }`,
      )
    }
    if (roof_pitch) {
      notesLines.push(`Roof pitch: ${roof_pitch}`)
    }
    if (roof_tear_material) {
      notesLines.push(`Material duration: ${roof_tear_material} years`)
    }

    if (roof_square_footage && roof_layover_or_tear) {
      const layoverPrice = (() => {
        if (state === 'california') {
          return priceList.find(
            (cp) => cp.label === schema.RoofWorkType.Layover,
          )!.value
        }
        return priceList.find((cp) => cp.label === schema.RoofWorkType.Layover)!
          .value
      })()
      const reRoofShinglesPrice = (() => {
        const price20y = priceList.find(
          (cp) => cp.label === 'Re Roof (Shingles) (20 years)',
        )!.value
        const price30y = priceList.find(
          (cp) => cp.label === 'Re Roof (Shingles) (30 years)',
        )!.value
        const price50y = priceList.find(
          (cp) => cp.label === 'Re Roof (Shingles) (50 years)',
        )!.value

        return (
          {
            20: price20y,
            30: price30y,
            50: price50y,
          }[roof_tear_material] || 0
        )
      })()
      const tilePrice = priceList.find(
        (cp) => cp.label === 'Tile (per sq)',
      )!.value
      const underlaymentReplPrice = priceList.find(
        (cp) => cp.label === 'Underlayment Replacement (per sq)',
      )!.value
      const reRoofFlatPrice = priceList.find(
        (cp) => cp.label === 'Re Roof (Flat roof) per sq',
      )!.value
      const reRoofWoodShakePrice = (() => {
        // const price20y = priceList.find(
        //   (cp) => cp.label === 'Re Roof (Woodshake) (20 years)',
        // )!.value
        const price30y = priceList.find(
          (cp) => cp.label === 'Re Roof (Woodshake) per sq (30 years)',
        )!.value
        // const price50y = priceList.find(
        //   (cp) => cp.label === 'Re Roof (Woodshake) (50 years)',
        // )!.value

        return (
          {
            // 20: price20y,
            30: price30y,
            // 50: price50y,
          }[roof_tear_material] || 0
        )
      })()

      const pricePerSq =
        {
          [schema.RoofWorkType.Layover]: layoverPrice,
          [schema.RoofWorkType.ReRoofShingles]: reRoofShinglesPrice,
          [schema.RoofWorkType.TileRepl]: tilePrice,
          [schema.RoofWorkType.UnderlaymentRepl]: underlaymentReplPrice,
          [schema.RoofWorkType.ReRoofFlatRoof]: reRoofFlatPrice,
          [schema.RoofWorkType.ReRoofWoodShake]: reRoofWoodShakePrice,
        }[roof_layover_or_tear] || -1

      const roofSquares = utils.parseFloating(roof_square_footage)

      finalCost += pricePerSq * roofSquares

      if (utils.isNumber(roof_pitch) && Number(roof_pitch) >= 8) {
        const price = priceList.find(
          ({ label }) => label === 'High pitch roof fee (per sq)',
        )!.value

        finalCost += roofSquares * price
      }

      if (roof_layers_how_many) {
        if (roof_layover_or_tear === schema.RoofWorkType.ReRoofShingles) {
          const additionalLayersPrice = priceList.find(
            (cp) => cp.label === 'Tear-off cost per additional layer',
          )!.value

          notesLines.push(
            `Number of current shingle layers: ${roof_layers_how_many}`,
          )
          const additionalLayers = utils.parseInteger(roof_layers_how_many) - 1
          if (additionalLayers > 0) {
            finalCost += additionalLayersPrice * additionalLayers * roofSquares
            notesLines.push(
              `Number of additional layers (Tear-off): ${additionalLayers}`,
            )
          }
        } else if (roof_layover_or_tear === schema.RoofWorkType.Layover) {
          notesLines.push(
            `Number of layers to be installed: ${roof_layers_how_many}`,
          )
        } else {
          notesLines.push(`Current roof layers: ${roof_layers_how_many}`)
        }
      }
    }

    if (
      roof_layover_or_tear === schema.RoofWorkType.ReRoofShingles ||
      (roof_layover_or_tear === schema.RoofWorkType.TileRepl &&
        roof_plywood_under_tile === 'yes') ||
      roof_layover_or_tear === schema.RoofWorkType.UnderlaymentRepl ||
      roof_layover_or_tear === schema.RoofWorkType.ReRoofFlatRoof ||
      roof_layover_or_tear === schema.RoofWorkType.ReRoofWoodShake
    ) {
      if (roof_plywood_replaced === 'yes' && roof_plywood_replaced_square) {
        const roofPlywoodPrice = (() => {
          if (state === 'california') {
            return prices.roof.california.pricesByCity[0]!.list.find(
              (cp) => cp.label === 'Plywood replacement per sq',
            )!.value
          }
          return prices.roof[state].list.find(
            (cp) => cp.label === 'Plywood replacement per sq',
          )!.value
        })()

        finalCost +=
          roofPlywoodPrice * utils.parseFloating(roof_plywood_replaced_square)
        notesLines.push(
          `${roof_plywood_replaced_square} sq of plywood will be replaced`,
        )
      } else {
        notesLines.push('Plywood will be replaced as needed')
      }
    }

    if (roof_fascia_included === 'yes' && roof_fascia_included_square_footage) {
      const roofFasciaPrice = (() => {
        if (state === 'california') {
          return prices.roof.california.pricesByCity[0]!.list.find(
            (cp) => cp.label === 'Roof Fascia per linear ft',
          )!.value
        }
        return prices.roof[state].list.find(
          (cp) => cp.label === 'Roof Fascia per linear ft',
        )!.value
      })()

      finalCost +=
        roofFasciaPrice *
        utils.parseFloating(roof_fascia_included_square_footage)

      notesLines.push(
        `Fascia included with ${roof_fascia_included_square_footage} sq`,
      )
    }

    if (roof_patio_included === 'yes' && roof_patio_how_many) {
      const roofPatioPrice = (() => {
        if (state === 'california') {
          return prices.roof.california.pricesByCity[0]!.list.find(
            (cp) => cp.label === 'Flat roof per sq',
          )!.value
        }
        return prices.roof[state].list.find(
          (cp) => cp.label === 'Flat roof per sq',
        )!.value
      })()

      finalCost += roofPatioPrice * utils.parseFloating(roof_patio_how_many)
      notesLines.push(`Patio included with ${roof_patio_how_many} sq`)
    }

    if (roof_layover_or_tear === schema.RoofWorkType.Layover) {
      notesLines.push('Scope of work:')
      notesLines.push(
        '- Inspecting the existing roof to confirm suitability for a layover.',
      )
      notesLines.push(
        '- Cleaning and preparing the surface of the existing shingles.',
      )
      notesLines.push(
        '- Furnishing and installing a new layer of architectural shingles (Owens Corning Oakridge series or similar product, depending on availability) with all associated flashings and trims.',
      )
      notesLines.push(
        '- Installing new drip edge metal and all new underlayment per local codes.',
      )
      notesLines.push(
        '- All job-related debris will be cleaned up and hauled away.',
      )
      notesLines.push('- Permits are included.')
    }
    if (roof_layover_or_tear === schema.RoofWorkType.ReRoofShingles) {
      notesLines.push('Scope of work:')
      notesLines.push(
        '- Removing the layers of existing roof down to the roof sheathing. (1 layer)',
      )
      notesLines.push(
        '- Inspecting the roof sheathing for damage, if damaged wood is discovered we will replace it.',
      )
      notesLines.push('- All debris will be cleaned up and hauled away.')
      notesLines.push(
        '- We will furnish and install new drip edge metal and all new underlayment in accordance with local codes.',
      )
      notesLines.push(
        '- We propose to furnish and install a new layer of architectural shingles (Owens Corning Oakridge series or similar product, depending on availability) with all associated flashings and trims.',
      )
      notesLines.push('-Permits are included.')
    }
    if (roof_layover_or_tear === schema.RoofWorkType.TileRepl) {
      notesLines.push('Scope of work:')
      notesLines.push(
        '- Preparation: Secure the site, protect landscaping, and set up debris disposal.',
      )
      notesLines.push(
        '- Tile Removal: Remove old tiles, dispose of debris, and clean roof surfaces.',
      )
      notesLines.push(
        '- Underlayment Replacement: Replace old underlayment with new material.',
      )
      notesLines.push(
        '- Plywood Inspection/Repair: Inspect plywood; replace damaged areas.',
      )
      notesLines.push(
        '- New Tile Installation: Install and align new tiles; seal edges and flashing.',
      )
      notesLines.push('- Cleanup: Remove debris and ensure the site is clean.')
      notesLines.push(
        '- Final Inspection: Conduct a final inspection to ensure the roof is properly sealed and secure.) this will appear as soon as we set the license question.',
      )
    }
    if (roof_layover_or_tear === schema.RoofWorkType.UnderlaymentRepl) {
      notesLines.push('Scope of work:')
      notesLines.push(
        '- Site Preparation: Set up safety measures and clear the work area.',
      )
      notesLines.push(
        '- Tile Removal: Carefully remove existing tiles, ensuring no damage.',
      )
      notesLines.push(
        '- Roof Surface Assessment: Inspect and prepare the roof deck, addressing any damage.',
      )
      notesLines.push(
        '- Underlayment Replacement: Install new underlayment with proper overlap and secure attachment.',
      )
      notesLines.push(
        '- Tile Reinstallation: Reinstall the removed tiles, replacing any broken ones with new tiles.',
      )
      notesLines.push('- Cleanup: Remove debris and ensure the site is clean.')
      notesLines.push(
        '- Final Inspection: Conduct a final inspection to ensure the roof is properly sealed and secure.) this will appear as soon as we set the license question.',
      )
    }
    if (roof_layover_or_tear === schema.RoofWorkType.ReRoofFlatRoof) {
      notesLines.push('\n')
      notesLines.push('Scope of work:')
      notesLines.push('\n')
      notesLines.push('1. Roof Removal:')
      notesLines.push(
        '- Remove the existing flat roofing system down to the roof decking, including any previous membrane, insulation, or underlayment materials.',
      )
      notesLines.push(
        '- Haul away and properly dispose of all roofing debris in accordance with local regulations.',
      )
      notesLines.push('\n')
      notesLines.push('2. Roof Deck Inspection:')
      notesLines.push(
        '- Inspect the exposed decking for water damage, rot, or structural issues.',
      )
      notesLines.push(
        '- Replace any damaged sheathing with like-kind materials. Decking repairs are included in the scope.',
      )
      notesLines.push('\n')
      notesLines.push('3. Substrate Preparation:')
      notesLines.push(
        '- Clean and prepare the roof surface to receive the new roofing system.',
      )
      notesLines.push(
        '- Install recovery board or insulation (if required), mechanically fastened or adhered as needed.',
      )
      notesLines.push('\n')
      notesLines.push('4. New Torch Down Roofing System Installation:')
      notesLines.push(
        '- Install a torch-applied modified bitumen system, consisting of:',
      )
      notesLines.push(
        '- Base sheet, either mechanically fastened or adhered to the substrate',
      )
      notesLines.push(
        '- Cap sheet torch-applied to form a watertight, durable top layer',
      )
      notesLines.push(
        '- Ensure full adhesion at seams, edges, and penetrations using torching techniques per manufacturer specifications.',
      )
      notesLines.push(
        '- Apply granule-surfaced cap sheet for UV protection and longevity.',
      )
      notesLines.push('\n')
      notesLines.push('5. Flashings & Penetrations:')
      notesLines.push(
        '- Install new metal flashing at all roof edges, parapet walls, vents, drains, and penetrations.',
      )
      notesLines.push(
        '- All flashings will be integrated into the roofing system for a watertight seal.',
      )
      notesLines.push(
        '- Use compatible roofing cement or sealant where required.',
      )
      notesLines.push('\n')
      notesLines.push('6. Drainage:')
      notesLines.push(
        '- Inspect and clean all existing roof drains and scuppers to ensure proper drainage.',
      )
      notesLines.push(
        '- Modify or replace any components that interfere with water flow (if required and specified).',
      )
      notesLines.push('\n')
      notesLines.push('7. Cleanup & Disposal:')
      notesLines.push('- Maintain a clean work area throughout the project.')
      notesLines.push(
        '- Remove all debris, old materials, and trash from the property at project completion.',
      )
    }
    if (roof_layover_or_tear === schema.RoofWorkType.ReRoofWoodShake) {
      notesLines.push('\n')
      notesLines.push('Scope of work:')
      notesLines.push('\n')
      notesLines.push('1. Roof Removal:')
      notesLines.push(
        '- Remove the entire existing roofing system, including all wood shake shingles, felt, battens, and any associated materials, down to the open rafters.',
      )
      notesLines.push(
        '- Carefully remove nails, fasteners, and debris to ensure a clean substrate for new decking.',
      )
      notesLines.push(
        '- All debris will be hauled offsite and disposed of in compliance with local regulations.',
      )
      notesLines.push('\n')
      notesLines.push('2. New Plywood Deck Installation:')
      notesLines.push(
        '- Install new plywood decking over the existing rafters to create a solid nailable surface.',
      )
      notesLines.push(
        '- Fasten decking securely using code-approved fasteners and spacing to provide structural stability.',
      )
      notesLines.push(
        '- Replace or add blocking or supports if required for code compliance or ventilation upgrades.',
      )
      notesLines.push('\n')
      notesLines.push('3. Drip Edge Installation:')
      notesLines.push(
        '- Install new aluminum or galvanized drip edge metal along all eaves and rakes to protect the deck edges and assist in proper water runoff.',
      )
      notesLines.push('\n')
      notesLines.push('4. Underlayment Installation:')
      notesLines.push(
        '- Install high-quality synthetic underlayment or 30# felt across the entire roof surface in compliance with local code and manufacturer requirements.',
      )
      notesLines.push(
        '- Underlayment will be properly lapped and fastened to ensure a continuous water barrier.',
      )
      notesLines.push('\n')
      notesLines.push('5. New Shingle Installation:')
      notesLines.push(
        '- Install new architectural asphalt shingles, such as Owens Corning Oakridge (or equivalent), with starter strips, ridge caps, and proper ventilation components.',
      )
      notesLines.push(
        '- Shingles will be installed per manufacturer specifications to qualify for product warranties and meet wind uplift and performance standards.',
      )
      notesLines.push('\n')
      notesLines.push('6. Flashings & Roof Details:')
      notesLines.push(
        '- Install new flashing around all penetrations (vents, chimneys, skylights, etc.), valleys, and roof-to-wall intersections.',
      )
      notesLines.push(
        '- Flashing materials will be compatible with the new roofing system and securely integrated for watertight performance.',
      )
      notesLines.push('\n')
      notesLines.push('7. Cleanup & Disposal:')
      notesLines.push(
        '- Maintain a clean worksite throughout the duration of the project.',
      )
      notesLines.push(
        '- At project completion, perform a thorough final cleanup and remove all roofing-related debris from the property.',
      )
    }

    if (roof_will_add_license === 'no') {
      finalCost -= 1000
    }
    if (roof_commission_add_up) {
      finalCost += utils.parseFloating(roof_commission_add_up)
    }

    return [finalCost, notesLines.join('\n')]
  },
  security_cams({ security_cams_detail }, prices, state) {
    let finalCost = 0
    const notesLines: string[] = []

    const priceList =
      state === 'california'
        ? prices.security_cams.california.pricesByCity[0]!.list
        : prices.security_cams[state].list

    const camGroups = JSON.parse(
      security_cams_detail || '[]',
    ) as schema.CamGroup[]

    const filledOutRows = camGroups.filter((cg) => !!cg.qty && !!cg.type)

    if (filledOutRows.length === 0) {
      return [0, '']
    }

    for (const { notes, qty, type } of filledOutRows) {
      const price = priceList.find((p) => p.label === type)!.value

      finalCost += qty * price

      notesLines.push(`${qty} x ${type}` + (notes ? ` (${notes})` : ''))
    }

    return [finalCost, notesLines.join('\n')]
  },
  security_wifi_cameras({ security_wifi_cameras_detail }, prices, state) {
    let finalCost = 0
    const notesLines: string[] = []

    const priceList =
      state === 'california'
        ? prices.security_wifi_cameras.california.pricesByCity[0]!.list
        : prices.security_wifi_cameras[state].list

    const camGroups = JSON.parse(
      security_wifi_cameras_detail || '[]',
    ) as schema.CamGroup[]

    const filledOutRows = camGroups.filter((cg) => !!cg.qty && !!cg.type)

    if (filledOutRows.length === 0) {
      return [0, '']
    }

    for (const { notes, qty, type } of filledOutRows) {
      const price = priceList.find((p) => p.label === type)!.value

      finalCost += qty * price

      notesLines.push(`${qty} x ${type}` + (notes ? ` (${notes})` : ''))
    }

    return [finalCost, notesLines.join('\n')]
  },
  security_system({ security_system_detail }, prices, state) {
    let finalCost = 0
    const notesLines: string[] = []

    const priceList =
      state === 'california'
        ? prices.security_system.california.pricesByCity[0]!.list
        : prices.security_system[state].list

    const secSysGroups = JSON.parse(
      security_system_detail || '[]',
    ) as schema.SecSysGroup[]

    const filledOutRows = secSysGroups.filter((ssg) => !!ssg.qty && !!ssg.type)

    if (filledOutRows.length === 0) {
      return [0, '']
    }

    for (const { notes, qty, type } of filledOutRows) {
      const price = priceList.find((p) => p.label === type)!.value

      finalCost += qty * price

      notesLines.push(`${qty} x ${type}` + (notes ? ` (${notes})` : ''))
    }

    return [finalCost, notesLines.join('\n')]
  },
  security_tv({ security_tv_detail }, prices, state) {
    let finalCost = 0
    const notesLines: string[] = []

    const priceList =
      state === 'california'
        ? prices.security_tv.california.pricesByCity[0]!.list
        : prices.security_tv[state].list

    const securityTvRows = JSON.parse(
      security_tv_detail || '[]',
    ) as schema.SecurityTVs

    const filledOutRows = securityTvRows.filter((ssg) => !!ssg.type)

    if (filledOutRows.length === 0) {
      return [0, '']
    }

    for (const { type } of filledOutRows) {
      const price = priceList.find((p) => p.label.startsWith(type))!.value

      finalCost += price

      notesLines.push(`1 x ${type}`)
    }

    return [finalCost, notesLines.join('\n')]
  },
  service_and_repair({ service_and_repair_hours }, prices, state) {
    if (!service_and_repair_hours) {
      return [0, '']
    }

    const priceList =
      state === 'california'
        ? prices.service_and_repair.california.pricesByCity[0]!.list
        : prices.service_and_repair[state].list

    const firstHourPrice = priceList.find(
      (p) => p.label === 'Minimum charge (first hour)',
    )!.value

    let finalCost = firstHourPrice

    const additionalHours = utils.parseFloating(service_and_repair_hours) - 1

    const pricePerHour = priceList.find(
      (p) => p.label === 'Charge per hour after the first',
    )!.value
    finalCost += pricePerHour * additionalHours

    return [
      finalCost,
      `${service_and_repair_hours} hour${
        additionalHours ? 's' : ''
      } of service and repairs work`,
    ]
  },
  small_system(
    {
      main_panel_upgrade_installation_company,
      small_system_size,
      small_system_extra_batteries_qty,
      small_system_extra_batteries_will,
    },
    prices,
    state,
  ) {
    if (!main_panel_upgrade_installation_company || !small_system_size) {
      return [0, '']
    }

    let finalCost = 0
    const notesLines: string[] = []

    const priceList =
      state === 'california'
        ? prices.small_system.california.pricesByCity[0]!.list
        : prices.small_system[state].list

    const sizeToPrice = {
      '6kw': priceList.find((p) => p.label === '6kw system')!.value,
      '12kw': priceList.find((p) => p.label === '12kw system')!.value,
      '18kw': priceList.find((p) => p.label === '18kw system')!.value,
    }

    const price = sizeToPrice[small_system_size as keyof typeof sizeToPrice]

    finalCost += price

    notesLines.push(`System size: ${small_system_size}`)

    notesLines.push(`Includes 6 panels and one 14.3kw battery`)

    if (
      small_system_extra_batteries_will === 'yes' &&
      small_system_extra_batteries_qty
    ) {
      const extraBatteriesParsed = utils.parseInt(
        small_system_extra_batteries_qty,
      )
      const additionalBatteryPrice = priceList.find(
        (p) => p.label === 'Additional battery (ea)',
      )!.value

      finalCost += extraBatteriesParsed * additionalBatteryPrice

      if (extraBatteriesParsed === 1) {
        notesLines.push(`1 extra battery will be installed`)
      } else if (extraBatteriesParsed > 1) {
        notesLines.push(
          `${small_system_extra_batteries_qty} extra batteries will be installed`,
        )
      }
    }

    const miscPrice = priceList.find(
      (p) => p.label === 'Misc (wiring, etc.)',
    )!.value

    finalCost += miscPrice

    return [finalCost, notesLines.join('\n')]
  },
  smart_thermostat({ smart_thermostat_how_many }, prices, state) {
    let finalCost = 0
    const notesLines: string[] = []

    const price = (() => {
      if (state === 'california') {
        return prices.smart_thermostat.california.pricesByCity[0]!.list[0]!
          .value
      }
      return prices.smart_thermostat[state].list[0]!.value
    })()

    if (smart_thermostat_how_many) {
      finalCost += price * utils.parseInteger(smart_thermostat_how_many)
      notesLines.push(
        `${smart_thermostat_how_many} smart thermostats will be installed`,
      )
    }

    return [finalCost, notesLines.join('\n')]
  },
}

export const addUpWindows = (customer: Customer): number | string => {
  try {
    const windows = JSON.parse(
      customer.new_windows_sqft_each_window || '[]',
    ) as schema.WindowGroup[]

    return windows
      .filter((w) => !!w.size)
      .reduce((acc, curr) => acc + utils.parseInt(curr.window), 0)
  } catch (e) {
    const msg = `Error adding up windows: ${utils.processErr(e)}`
    utils.log(e)
    return msg
  }
}

export const addUpSlidingDoors = (customer: Customer): number | string => {
  try {
    if (customer.new_windows_sliding_glass === 'no') {
      return 0
    }
    const slidingDoors = JSON.parse(
      (customer.new_windows_sliding_glass_sqft as string) || '[]',
    ) as schema.SlidingGlassDoorGroup[]

    return slidingDoors
      .filter((s) => !!s.size)
      .reduce((acc, curr) => acc + utils.parseInt(curr.total), 0)
  } catch (e) {
    const msg = `Error adding up sliding doors: ${utils.processErr(e)}`
    utils.log(e)
    return msg
  }
}

/**
 * In order to apply the loan to all efficiencies, we need to know which ones
 * are actually filled, sometimes this is done via the calculator (if it returns
 * 0 the efficiency isn't fully filled in) but this is a hack.
 */
const efficiencyToIsFilled: FieldToTrait<
  (customer: schema.Customer) => boolean
> = {
  air_conditioner({
    air_conditioner_current_tons,
    air_conditioner_furnance,
    air_conditioner_new_tons,
    air_conditioner_replace_ducts,
    air_conditioner_swamp_cooler_use_remove,
    air_conditioner_swamp_cooler_use,
    air_conditioner_unit_type,
    air_conditioner_working,
  }) {
    if (!air_conditioner_working) {
      return false
    }
    if (air_conditioner_working === 'yes') {
      if (!air_conditioner_current_tons) {
        return false
      }
      if (!air_conditioner_replace_ducts) {
        return false
      }
    }
    if (!air_conditioner_swamp_cooler_use) {
      return false
    }
    if (air_conditioner_swamp_cooler_use === 'yes') {
      if (!air_conditioner_swamp_cooler_use_remove) {
        return false
      }
    }
    if (!air_conditioner_new_tons) {
      return false
    }
    if (!air_conditioner_unit_type) {
      return false
    }
    if (air_conditioner_unit_type.startsWith('split_')) {
      if (!air_conditioner_furnance) {
        return false
      }
    }
    return true
  },
  attic_fan({ attic_fan_quantity }) {
    if (!attic_fan_quantity) {
      return false
    }
    return true
  },
  attic_insulation({ attic_insulation_type, attic_insulation_how_much }) {
    if (!attic_insulation_type) {
      return false
    }
    if (!attic_insulation_how_much) {
      return false
    }
    return true
  },
  battery_multiple({
    battery_multiple_bank_location,
    battery_multiple_how_many,
    battery_multiple_customer_material,
  }) {
    if (!battery_multiple_bank_location) {
      return false
    }
    if (!battery_multiple_how_many) {
      return false
    }
    if (!battery_multiple_customer_material) {
      return false
    }
    return true
  },
  battery({
    battery_type,
    battery_size,
    main_panel_upgrade_installation_company,
  }) {
    if (!battery_type) {
      return false
    }
    if (!battery_size) {
      return false
    }
    if (!main_panel_upgrade_installation_company) {
      return false
    }
    return true
  },
  can_light_new({
    can_light_new_how_many,
    can_light_new_will_remove,
    can_light_new_will_remove_how_many,
  }) {
    if (!can_light_new_how_many) {
      return false
    }
    if (
      can_light_new_will_remove === 'yes' &&
      !can_light_new_will_remove_how_many
    ) {
      return false
    }
    return true
  },
  // cash() {},
  ceiling_fan({ ceiling_fan_detail }) {
    const ceilingFans = JSON.parse(
      ceiling_fan_detail || '[]',
    ) as schema.CeilingFan[]

    return ceilingFans.filter((cf) => !!cf.type).length > 0
  },
  construction_work() {
    return true
  },
  derate({ main_panel_upgrade_installation_company }) {
    if (!main_panel_upgrade_installation_company) {
      return false
    }
    return true
  },
  duct_repair({ duct_repair_quantity }) {
    if (!duct_repair_quantity) {
      return false
    }
    return true
  },
  duct_replacement({ duct_replacement_qty }) {
    if (!duct_replacement_qty) {
      return false
    }
    return true
  },
  duct_seal() {
    return true
  },
  flat_roof_panels({ flat_roof_panels_how_many }) {
    if (!flat_roof_panels_how_many) {
      return false
    }
    return true
  },
  home_run({ home_run_ft }) {
    if (!home_run_ft) {
      return false
    }
    return true
  },
  inverter_swap({
    inverter_swap_qty,
    inverter_swap_size,
    inverter_swap_customer_material,
  }) {
    if (!inverter_swap_qty) {
      return false
    }
    if (!inverter_swap_size) {
      return false
    }
    if (!inverter_swap_customer_material) {
      return false
    }
    return true
  },
  main_panel_upgrade({
    main_panel_upgrade_rating,
    main_panel_upgrade_installation_company,
    main_panel_upgrade_needed_or_requested,
  }) {
    if (env.CODENAME === 'nirvana') {
      if (!main_panel_upgrade_rating) {
        return false
      }
      return true
    }
    if (!main_panel_upgrade_installation_company) {
      return false
    }
    if (!main_panel_upgrade_needed_or_requested) {
      return false
    }
    return true
  },
  mini_split({ mini_split_tons, roof_shingles_or_tiles }) {
    if (env.CODENAME === 'nirvana') {
      if (!roof_shingles_or_tiles) {
        return false
      }
      const miniSplits = JSON.parse(
        mini_split_tons || '[]',
      ) as schema.MiniSplit[]

      return miniSplits.filter((ms) => !!ms.tons).length > 0
    }
    if (!mini_split_tons) {
      return false
    }
    return true
  },
  new_windows({
    new_windows_sqft_each_window,
    new_windows_color,
    new_windows_grid,
    new_windows_sliding_glass,
    new_windows_sliding_glass_sqft,
    new_windows_replace,
  }) {
    // Doesn't take into account recent changes, won't work for older customers
    if (!new_windows_sqft_each_window) {
      return false
    }
    if (!new_windows_color) {
      return false
    }
    if (!new_windows_grid) {
      return false
    }
    if (!new_windows_sliding_glass) {
      return false
    }
    if (new_windows_sliding_glass === 'yes') {
      if (!new_windows_sliding_glass_sqft) {
        return false
      }
    }
    if (!new_windows_replace) {
      return false
    }
    return true
  },
  nirvana_panels({ nirvana_panels_panel_scenario, nirvana_panels_how_many }) {
    if (!nirvana_panels_panel_scenario) {
      return false
    }
    if (!nirvana_panels_how_many) {
      return false
    }
    return true
  },
  outlet({ outlet_detail }) {
    const outletGroups = JSON.parse(
      outlet_detail || '[]',
    ) as schema.OutletGroup[]

    return outletGroups.filter((og) => utils.parseInt(og.qty) > 0).length > 0
  },

  panel_removal({ panel_removal_how_many }) {
    if (!panel_removal_how_many) {
      return false
    }
    return true
  },
  pool_pump() {
    return true
  },
  protection({ protection_which }) {
    if (!protection_which) {
      return false
    }
    return true
  },
  roof({
    roof_square_footage,
    roof_pitch,
    roof_layover_or_tear,
    roof_layers_how_many,
    roof_tear_material,
    roof_fascia_included,
    roof_fascia_included_square_footage,
    roof_patio_included,
    roof_patio_how_many,
    roof_plywood_under_tile,
    roof_plywood_replaced,
    roof_plywood_replaced_square,
    roof_will_add_license,
  }) {
    // Doesn't take into account recent changes, won't work for older customers
    if (!roof_square_footage) {
      return false
    }
    if (!roof_pitch) {
      return false
    }
    if (!roof_layover_or_tear) {
      return false
    }
    if (
      roof_layover_or_tear === schema.RoofWorkType.ReRoofShingles ||
      roof_layover_or_tear === schema.RoofWorkType.ReRoofFlatRoof ||
      roof_layover_or_tear === schema.RoofWorkType.ReRoofWoodShake ||
      roof_layover_or_tear === schema.RoofWorkType.Layover
    ) {
      if (!roof_layers_how_many) {
        return false
      }
      if (
        roof_layover_or_tear === schema.RoofWorkType.ReRoofShingles ||
        roof_layover_or_tear === schema.RoofWorkType.ReRoofWoodShake
      ) {
        if (!roof_tear_material) {
          return false
        }
      }
    }
    if (roof_layover_or_tear === schema.RoofWorkType.TileRepl) {
      if (!roof_plywood_under_tile) {
        return false
      }
      if (roof_plywood_under_tile === 'yes') {
        if (!roof_plywood_replaced) {
          return false
        }
        if (roof_plywood_replaced === 'yes') {
          if (!roof_plywood_replaced_square) {
            return false
          }
        }
      }
    }
    if (
      roof_layover_or_tear === schema.RoofWorkType.ReRoofFlatRoof ||
      roof_layover_or_tear === schema.RoofWorkType.ReRoofShingles ||
      roof_layover_or_tear === schema.RoofWorkType.ReRoofWoodShake ||
      roof_layover_or_tear === schema.RoofWorkType.UnderlaymentRepl
    ) {
      if (!roof_plywood_replaced) {
        return false
      }
      if (roof_plywood_replaced === 'yes') {
        if (!roof_plywood_replaced_square) {
          return false
        }
      }
    }
    if (!roof_fascia_included) {
      return false
    }
    if (roof_fascia_included === 'yes') {
      if (!roof_fascia_included_square_footage) {
        return false
      }
      return true
    }
    if (!roof_patio_included) {
      return false
    }
    if (roof_patio_included === 'yes') {
      if (!roof_patio_how_many) {
        return false
      }
      return true
    }
    if (!roof_will_add_license) {
      return false
    }
    return true
  },
  security_cams({ security_cams_detail }) {
    if (!security_cams_detail) {
      return false
    }
    return true
  },
  security_wifi_cameras({ security_wifi_cameras_detail }) {
    if (!security_wifi_cameras_detail) {
      return false
    }
    return true
  },
  security_system({ security_system_detail }) {
    if (!security_system_detail) {
      return false
    }
    return true
  },
  security_tv({ security_tv_detail }) {
    if (!security_tv_detail) {
      return false
    }
    return true
  },
  service_and_repair({ service_and_repair_hours }) {
    if (!service_and_repair_hours) {
      return false
    }
    return true
  },
  small_system({
    main_panel_upgrade_installation_company,
    small_system_size,
    small_system_extra_batteries_will,
  }) {
    if (env.CODENAME === 'nirvana') {
      if (!small_system_size) {
        return false
      }
      if (!small_system_extra_batteries_will) {
        return false
      }
    } else {
      if (!main_panel_upgrade_installation_company) {
        return false
      }
    }
    return true
  },
  smart_thermostat({ smart_thermostat_how_many }) {
    if (!smart_thermostat_how_many) {
      return false
    }
    return true
  },
  custom_fields({ custom_fields_qty, custom_fields_name, custom_fields_cost }) {
    if (!custom_fields_qty) {
      return false
    }
    if (!custom_fields_name) {
      return false
    }
    if (!custom_fields_cost) {
      return false
    }
    return true
  },
  custom_two_fields({
    custom_two_fields_qty,
    custom_two_fields_name,
    custom_two_fields_cost,
  }) {
    if (!custom_two_fields_qty) {
      return false
    }
    if (!custom_two_fields_name) {
      return false
    }
    if (!custom_two_fields_cost) {
      return false
    }
    return true
  },
  custom_three_fields({
    custom_three_fields_qty,
    custom_three_fields_name,
    custom_three_fields_cost,
  }) {
    if (!custom_three_fields_qty) {
      return false
    }
    if (!custom_three_fields_name) {
      return false
    }
    if (!custom_three_fields_cost) {
      return false
    }
    return true
  },
  custom_four_fields({
    custom_four_fields_qty,
    custom_four_fields_name,
    custom_four_fields_cost,
  }) {
    if (!custom_four_fields_qty) {
      return false
    }
    if (!custom_four_fields_name) {
      return false
    }
    if (!custom_four_fields_cost) {
      return false
    }
    return true
  },
  custom_five_fields({
    custom_five_fields_qty,
    custom_five_fields_name,
    custom_five_fields_cost,
  }) {
    if (!custom_five_fields_qty) {
      return false
    }
    if (!custom_five_fields_name) {
      return false
    }
    if (!custom_five_fields_cost) {
      return false
    }
    return true
  },
  custom_six_fields({
    custom_six_fields_qty,
    custom_six_fields_name,
    custom_six_fields_cost,
  }) {
    if (!custom_six_fields_qty) {
      return false
    }
    if (!custom_six_fields_name) {
      return false
    }
    if (!custom_six_fields_cost) {
      return false
    }
    return true
  },
  custom_seven_fields({
    custom_seven_fields_qty,
    custom_seven_fields_name,
    custom_seven_fields_cost,
  }) {
    if (!custom_seven_fields_qty) {
      return false
    }
    if (!custom_seven_fields_name) {
      return false
    }
    if (!custom_seven_fields_cost) {
      return false
    }
    return true
  },
  custom_eight_fields({
    custom_eight_fields_qty,
    custom_eight_fields_name,
    custom_eight_fields_cost,
  }) {
    if (!custom_eight_fields_qty) {
      return false
    }
    if (!custom_eight_fields_name) {
      return false
    }
    if (!custom_eight_fields_cost) {
      return false
    }
    return true
  },
  custom_nine_fields({
    custom_nine_fields_qty,
    custom_nine_fields_name,
    custom_nine_fields_cost,
  }) {
    if (!custom_nine_fields_qty) {
      return false
    }
    if (!custom_nine_fields_name) {
      return false
    }
    if (!custom_nine_fields_cost) {
      return false
    }
    return true
  },
  custom_ten_fields({
    custom_ten_fields_qty,
    custom_ten_fields_name,
    custom_ten_fields_cost,
  }) {
    if (!custom_ten_fields_qty) {
      return false
    }
    if (!custom_ten_fields_name) {
      return false
    }
    if (!custom_ten_fields_cost) {
      return false
    }
    return true
  },
}

export type IContractDetailRow = utils.r<{
  description: string
  /**
   * Ideally this would be typed as required but firebase omits the property
   * when it's an empty array
   */
  notes?: string[]
  price: number
  qty: number
}>

export type TagToEfficiencies = utils.DictB<
  utils.RRecord<schema.CustomerField, true>
>

export type SharedContractNirvana = utils.r<{
  /**
   * report_nirvana_finance
   */
  amountFinance: string
  /**
   * report_nirvana_upfront
   */
  amountUpfront: string
  /**
   * report_nirvana_remaining
   */
  amountRemaining: string

  contractCompanyAddress1: string
  contractCompanyAddress2: string
  contractCompanyEmail?: string
  contractCompanyLogo: string
  contractCompanyLongName: string
  contractCompanyPhoneNumber: string
  contractCompanyRoofingLicense: string
  contractCompanyShortName: string
  contractCompanyStates: string

  customerAddress: string
  customerEmail: string
  customerName: string
  customerPhone: string
  customerPhoneAlt: string

  /**
   * The signature itself cannot be stored in a publicly accessible firebase
   * location, we'll only keep track of whether it's signed or not, the
   * signature itself will be saved into a publicly-writable but not
   * publicly-readable location, and this value here will keep track of the
   * shared contract already being signed.
   */
  customerSigned: boolean
  customerSignedDate?: number

  /**
   * homeRep
   */
  repName: string
  /**
   *
   */
  repSignatureDate?: number

  rows: IContractDetailRow[]

  /**
   * customer.solarCompany
   */
  state: string

  totalCostCustomer: number
}>

/**
 * Distributes a given partial loan amount into the "price" cells, the correct
 * percentage must be calculated beforehand. Rows without a quantity or type
 * cell will be discarded. Returns the resulting rows as an stringified array
 */
export const applyLoanToSecurity = (
  rows: schema.CamGroups | schema.SecSysGroups | schema.SecurityTVs,
  partialLoanAmt: number,
): string => {
  const filledRows:
    | schema.CamGroups
    | schema.SecSysGroups
    | schema.SecurityTVs = rows.filter(({ qty, type }) => qty > 0 && !!type)
  const total = filledRows.reduce((acc, { price, qty }) => acc + price * qty, 0)

  const result = filledRows.map(({ price, qty, ...rest }) => {
    const subtotal = price * qty
    const percentage = subtotal / total
    const thisRowLoanAmt = partialLoanAmt * percentage

    return {
      ...rest,
      price: Number(thisRowLoanAmt / qty).toFixed(2),
      qty,
    }
  })

  return JSON.stringify(result)
}

export const calcLoanMonthlyPay = (
  totalLoanAmount: number,
  interestRate: number,
  loanDurationYears: number,
): number => {
  // Step 1: Convert the annual interest rate to a monthly rate
  const monthlyRate = interestRate / 100 / 12

  // Step 2: Calculate the total number of payments
  const totalPayments = loanDurationYears * 12

  // Step 3: Apply the loan amortization formula
  const monthlyPayment =
    (totalLoanAmount *
      (monthlyRate * Math.pow(1 + monthlyRate, totalPayments))) /
    (Math.pow(1 + monthlyRate, totalPayments) - 1)

  return monthlyPayment
}

export const getFilledCustomFields = (
  customerData: Customer,
): schema.CustomerFields =>
  schema.customFields
    .filter((key) => !!schema.CustomerSchema[key])
    .filter((efficiency) => {
      const toggled = customerData[efficiency] === 'yes'

      const qtyFilled =
        utils.parseInt(
          customerData[(efficiency + '_qty') as schema.CustomerField],
        ) > 0
      const nameFilled =
        (customerData[(efficiency + '_name') as schema.CustomerField] as string)
          .length > 0
      const costFilled =
        !!customerData[(efficiency + '_customer_cost') as schema.CustomerField]

      return toggled && qtyFilled && nameFilled && costFilled
    })

export const getAddersWithCustomerCost = (
  customerData: Customer,
): schema.CustomerFields => {
  return efficiencyKeys
    .filter((key) => !!schema.CustomerSchema[key])
    .filter((efficiency) => {
      const toggled = customerData[efficiency] === 'yes'

      if (!toggled) {
        return false
      }

      const verifier = efficiencyToIsFilled[efficiency]

      if (verifier) {
        return verifier(customerData)
      }

      const customerCostStr =
        customerData[(efficiency + '_customer_cost') as schema.CustomerField]

      return !!customerCostStr
    })
}

export const buildContractRows = (
  customerData: schema.Customer,
): readonly IContractDetailRow[] => {
  return efficiencyKeys
    .filter((adder) => customerData[adder] === 'yes')
    .filter((adder) =>
      efficiencyToIsFilled[adder]
        ? efficiencyToIsFilled[adder](customerData)
        : true,
    )
    .map((adder): IContractDetailRow => {
      const isCustom = adder.startsWith('custom_')
      const description = isCustom
        ? (customerData[(adder + '_name') as schema.CustomerField] as string)
        : getFieldLabel(adder)
      const costCustomer = utils.parseFloating(
        customerData[(adder + '_customer_cost') as schema.CustomerField],
      )

      const qty = (() => {
        const rowable = adderToInputs[adder]!.find((f) =>
          schema.rowableFields.includes(
            //@ts-ignore
            f,
          ),
        ) as schema.FieldRowable | undefined
        if (rowable && schema.rowableFields.includes(rowable)) {
          type RowableNirvana =
            | schema.CeilingFan
            | schema.MiniSplit
            | schema.OutletGroup

          const rows = JSON.parse(
            customerData[rowable] || '[]',
          ) as readonly RowableNirvana[]

          const totalQty = rows.reduce((total, row) => {
            if (schema.rowIsMiniSplit(row)) {
              // Not filled
              if (!row.tons) {
                return total
              }
              // TODO: sometimes it gets converted to a string, fix pending
              return total + utils.parseInt(row.qty)
            }
            if (schema.rowIsOutletGroup(row)) {
              // TODO: sometimes it gets converted to a string, fix pending
              return total + utils.parseInt(row.qty)
            }
            if (schema.rowIsCeilingFan(row)) {
              if (!row.type) {
                return total
              }
              // TODO: sometimes it gets converted to a string, fix pending
              return total + 1
            }

            throw new TypeError(
              `Adding up qties for contract, unexpected row type, row: ${JSON.stringify(
                row,
              )}`,
            )
          }, 0)

          return totalQty
        }

        const maybeNumberInput =
          customerData[(adder + '_qty') as schema.CustomerField] ||
          customerData[(adder + '_how_many') as schema.CustomerField] ||
          customerData[(adder + '_ft') as schema.CustomerField]

        return utils.parseFloating(maybeNumberInput) || -1
      })()

      return {
        description,
        notes: utils.emptyArrStr,
        price: costCustomer / (qty === -1 ? 1 : qty),
        qty,
      }
    })
}

type CalcTotalCostParams = utils.r<{
  customer: schema.Customer | null | undefined
  deductDisabled?: boolean
  /**
   * Nirvana only
   */
  twoStoryFee: number
  type: 'company' | 'customer'
}>

export const calcTotalCost = ({
  customer,
  deductDisabled,
  twoStoryFee,
  type,
}: CalcTotalCostParams): number => {
  if (!customer) {
    // c.debug('useTotalCost() -> returning 0 as no customer found')
    return 0
  }

  const turnedOn = efficiencyKeys
    .filter((k) => customer[k] === 'yes')
    .filter((field) => {
      if (!deductDisabled) return true
      const showField =
        schema.normalizeCheckShows[field] ||
        ((field + '_show') as schema.CustomerField)
      return customer[showField] === 1
    })

  const costFields = turnedOn.map(
    (k) => k + (type === 'company' ? '_cost' : '_customer_cost'),
  )
  const costsStr = costFields.map(
    (k) => customer[k as schema.CustomerField],
  ) as utils.strings
  const costs = costsStr
    .map((cost) => utils.parseFloating(cost))
    // TODO: Is this really needed?
    .filter(Number.isFinite)

  let total = costs.reduce((acc, curr) => acc + curr, 0)

  // Must be mirrored in usePayment()
  if (
    env.CODENAME === 'nirvana' &&
    !customer.payment_is_applied &&
    type === 'customer'
  ) {
    if (customer.homeStoryNumber === '2') {
      total += utils.parseFloating(twoStoryFee)
    }
  }

  return total
}
